// Translation strings for all supported languages
export const translations = {
  en: {
    // Language names
    language: "Language",
    selectLanguage: "Select Language",
    chooseLanguage: "Choose your preferred language",
    
    // Form fields
    project: "Project",
    selectProject: "Select Project",
    yourName: "Your name",
    yourEmail: "Your email",
    videoLanguage: "Video Language",
    countryRecorded: "Country where video was recorded",
    selectFiles: "Select Files",
    
    // Placeholders
    enterFullName: "Enter your full name",
    enterEmail: "Enter your email address",
    selectLanguageOption: "-- Select language --",
    selectCountryOption: "-- Select country --",
    selectProjectOption: "-- Select a project --",
    
    // Buttons
    uploadAllFiles: "Upload ALL files",
    uploading: "Uploading...",
    retry: "Retry",
    clearAll: "Clear All",
    
    // File upload
    chooseFiles: "Choose Your Files",
    selectFilesToShare: "Select your files you want to share",
    uploadGuidelines: "Upload Guidelines:",
    maxFileSize: "Maximum file size: 10 GB",
    supportedFormats: "Supported formats:",
    secureStorage: "Your files will be securely stored in our cloud",
    stayOnPage: "Please stay on page during the uploading process",
    
    // Drag and drop
    dragDropFiles: "Drag and drop files here",
    orClickToSelect: "or click to select files",
    dropFilesHere: "Drop files here...",
    
    // Disclaimer
    authorizationTitle: "Authorization and Release Information",
    authorizationText: "I understand my submitted photos/videos (the \"Content\") can be publicly used on behalf of INCRUISES INTERNATIONAL, LLC (hereinafter called \"The Company\") in connection with publicizing and promoting The Company. I authorize The Company to use my name, brief biographical information, and the Content as defined in this form. I hereby irrevocably authorize The Company to copy, exhibit, publish or distribute the Content for purposes of publicizing The Company's programs or for any other lawful purpose. These statements may be used in printed publications, multimedia presentations, on websites or in any other distribution media. I further agree that I will make no monetary nor other claim against The Company for the use of the Content. In addition, I waive any right to inspect or approve the finished product, including written copy, wherein my name, likeness, or Content appears. I hereby hold harmless and release The Company from all claims, demands, and causes of action which I, my heirs, representatives, executors, administrators, or any other persons acting on my behalf or on behalf of my estate have or may have by reason of this authorization.",
    consentCheckbox: "I have read the authorization and release information and give my consent for the use as indicated above.",
    
    // Validation messages
    nameRequired: "Name is required",
    nameMinLength: "Name must be at least 2 characters long",
    nameMaxLength: "Name must be less than 100 characters",
    nameInvalidChars: "Name can only contain letters, spaces, hyphens, and apostrophes",
    emailRequired: "Email is required",
    emailInvalid: "Please enter a valid email address",
    emailTooLong: "Email address is too long",
    projectRequired: "Please select a project.",
    consentRequired: "Please read and accept the authorization and release information.",
    
    // File input hints
    fillName: "Please fill in a valid name to enable file selection.",
    fillEmail: "Please fill in a valid email to enable file selection.",
    selectProjectRequired: "Please select a project to enable file selection.",
    acceptConsent: "Please read and accept the authorization and release information above to enable file selection.",
    fillNameAndEmail: "Please fill in valid name and email to enable file selection.",
    selectProjectAndConsent: "Please select a project and accept the authorization and release information to enable file selection.",
    selectProjectAndFill: "Please select a project and fill in a valid {field} to enable file selection.",
    fillAndConsent: "Please fill in a valid {field} and accept the authorization and release information to enable file selection.",
    allRequired: "Please select a project, fill in all required fields (name, email) with valid information, and accept the authorization and release information to enable file selection.",
    
    // Upload status
    uploadsHistory: "Uploads History",
    initializing: "Initializing",
    ready: "Ready",
    queued: "Queued",
    uploadingStatus: "Uploading",
    paused: "Paused",
    completed: "Completed",
    cancelled: "Cancelled",
    error: "Error",
    
    // Loading
    loadingProjects: "Loading projects...",
    
    // Errors
    failedToLoadProjects: "Failed to load projects.",
    cannotConnect: "Cannot connect to server. Please make sure the server is running.",
    
    // Project messages
    uploadingForProject: "You are going to upload files for",
    projectLabel: "project.",
    cannotChangeProject: "Cannot change project. Please upload, cancel, or delete all files for the current project first.",
    
    // Required indicator
    required: "*",
    
    // Upload control buttons
    upload: "Upload",
    resume: "Resume",
    pause: "Pause",
    cancel: "Cancel",
    current: "(Current)",
    errorLabel: "Error:",
    removeFromList: "Remove from upload list",
    dismissError: "Dismiss error",
    readyForUploading: "ready for uploading",
    
    // File format names
    videoFiles: "Video files",
    audioFiles: "Audio files",
    imageFiles: "Image files",
    documents: "Documents",
    archiveFiles: "Archive files",
    rawOtherFormats: "Raw/Other formats",

    // Completion modal
    completionThankYou: "Thank you for your submission!",
    completionFailedIntro: "The following files failed to be uploaded:",
    completionUploadMore: "Upload more",

    // Footer
    followUs: "FOLLOW US ON",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© 2015 to Present inGroup International. All rights reserved.",

    // Video tip
    videoTipMessage: "Check this guide for tips on filming videos with a smartphone:",
    videoTipLinkText: "GUIDE",
  },
  
  ca: {
    language: "Idioma",
    selectLanguage: "Selecciona l'idioma",
    chooseLanguage: "Tria el teu idioma preferit",
    project: "Projecte",
    selectProject: "Selecciona el projecte",
    yourName: "El teu nom",
    yourEmail: "El teu correu electrònic",
    videoLanguage: "Idioma del vídeo",
    countryRecorded: "País on es va gravar el vídeo",
    selectFiles: "Selecciona fitxers",
    enterFullName: "Introdueix el teu nom complet",
    enterEmail: "Introdueix el teu correu electrònic",
    selectLanguageOption: "-- Selecciona l'idioma --",
    selectCountryOption: "-- Selecciona el país --",
    selectProjectOption: "-- Selecciona un projecte --",
    uploadAllFiles: "Puja TOTS els fitxers",
    uploading: "Pujant...",
    retry: "Torna a intentar",
    clearAll: "Esborra tot",
    chooseFiles: "Tria els teus fitxers",
    selectFilesToShare: "Selecciona els fitxers que vols compartir",
    uploadGuidelines: "Directrius de pujada:",
    maxFileSize: "Mida màxima del fitxer: 10 GB",
    supportedFormats: "Formats compatibles:",
    secureStorage: "Els teus fitxers s'emmagatzemaran de forma segura al nostre núvol",
    stayOnPage: "Si us plau, romàn a la pàgina durant el procés de pujada",
    
    // Drag and drop
    dragDropFiles: "Arrossega i deixa anar els fitxers aquí",
    orClickToSelect: "o fes clic per seleccionar fitxers",
    dropFilesHere: "Deixa anar els fitxers aquí...",
    authorizationTitle: "Informació d'autorització i alliberament",
    authorizationText: "Entenc que les meves fotos/vídeos enviats (el \"Contingut\") poden ser utilitzats públicament en nom d'INCRUISES INTERNATIONAL, LLC (en endavant anomenada \"L'Empresa\") en relació amb la publicització i promoció de L'Empresa. Autoritzo L'Empresa a utilitzar el meu nom, informació biogràfica breu i el Contingut tal com es defineix en aquest formulari. Per la present, autoritzo de forma irrevocable L'Empresa a copiar, exposar, publicar o distribuir el Contingut amb finalitats de publicització dels programes de L'Empresa o per a qualsevol altre propòsit legal. Aquestes declaracions poden ser utilitzades en publicacions impreses, presentacions multimèdia, a llocs web o en qualsevol altre mitjà de distribució. A més, accepto que no faré cap reclamació monetària ni d'altre tipus contra L'Empresa per l'ús del Contingut. A més, renuncio a qualsevol dret a inspeccionar o aprovar el producte final, incloent-hi el text escrit, on aparegui el meu nom, semblança o Contingut. Per la present, exonero i allibero L'Empresa de totes les reclamacions, demandes i causes d'acció que jo, els meus hereus, representants, executors, administradors o qualsevol altra persona que actuï en el meu nom o en nom del meu patrimoni tinc o puc tenir per raó d'aquesta autorització.",
    consentCheckbox: "He llegit la informació d'autorització i alliberament i dono el meu consentiment per a l'ús tal com s'indica anteriorment.",
    nameRequired: "El nom és obligatori",
    nameMinLength: "El nom ha de tenir almenys 2 caràcters",
    nameMaxLength: "El nom ha de tenir menys de 100 caràcters",
    nameInvalidChars: "El nom només pot contenir lletres, espais, guions i apostrofs",
    emailRequired: "El correu electrònic és obligatori",
    emailInvalid: "Si us plau, introdueix una adreça de correu electrònic vàlida",
    emailTooLong: "L'adreça de correu electrònic és massa llarga",
    projectRequired: "Si us plau, selecciona un projecte.",
    consentRequired: "Si us plau, llegeix i accepta la informació d'autorització i alliberament.",
    fillName: "Si us plau, introdueix un nom vàlid per habilitar la selecció de fitxers.",
    fillEmail: "Si us plau, introdueix un correu electrònic vàlid per habilitar la selecció de fitxers.",
    selectProjectRequired: "Si us plau, selecciona un projecte per habilitar la selecció de fitxers.",
    acceptConsent: "Si us plau, llegeix i accepta la informació d'autorització i alliberament anterior per habilitar la selecció de fitxers.",
    fillNameAndEmail: "Si us plau, introdueix un nom i correu electrònic vàlids per habilitar la selecció de fitxers.",
    selectProjectAndConsent: "Si us plau, selecciona un projecte i accepta la informació d'autorització i alliberament per habilitar la selecció de fitxers.",
    selectProjectAndFill: "Si us plau, selecciona un projecte i introdueix un {field} vàlid per habilitar la selecció de fitxers.",
    fillAndConsent: "Si us plau, introdueix un {field} vàlid i accepta la informació d'autorització i alliberament per habilitar la selecció de fitxers.",
    allRequired: "Si us plau, selecciona un projecte, introdueix tots els camps obligatoris (nom, correu electrònic) amb informació vàlida i accepta la informació d'autorització i alliberament per habilitar la selecció de fitxers.",
    uploadsHistory: "Historial de pujades",
    initializing: "Inicialitzant",
    ready: "Llest",
    queued: "En cua",
    uploadingStatus: "Pujant",
    paused: "Pausat",
    completed: "Completat",
    cancelled: "Cancel·lat",
    error: "Error",
    loadingProjects: "Carregant projectes...",
    failedToLoadProjects: "No s'han pogut carregar els projectes.",
    cannotConnect: "No es pot connectar al servidor. Si us plau, assegura't que el servidor està en funcionament.",
    uploadingForProject: "Pujaràs fitxers per al projecte",
    projectLabel: ".",
    cannotChangeProject: "No es pot canviar el projecte. Si us plau, puja, cancel·la o esborra tots els fitxers del projecte actual primer.",
    required: "*",
    upload: "Pujar",
    resume: "Reprendre",
    pause: "Pausar",
    cancel: "Cancel·lar",
    current: "(Actual)",
    errorLabel: "Error:",
    removeFromList: "Eliminar de la llista de pujades",
    dismissError: "Descartar error",
    readyForUploading: "llest per pujar",
    videoFiles: "Fitxers de vídeo",
    audioFiles: "Fitxers d'àudio",
    imageFiles: "Fitxers d'imatge",
    documents: "Documents",
    archiveFiles: "Fitxers d'arxiu",
    rawOtherFormats: "Formats raw/altres",
    completionThankYou: "Gràcies pel teu enviament!",
    completionFailedIntro: "Els següents fitxers no s'han pogut pujar:",
    completionUploadMore: "Pujar més",

    // Footer
    followUs: "SEGUEIX-NOS A",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© 2015 fins a l'actualitat inGroup International. Tots els drets reservats.",

    // Video tip
    videoTipMessage: "Consulteu aquesta guia per a consells per filmar vídeos amb un telèfon intel·ligent:",
    videoTipLinkText: "GUIA",
  },
  
  de: {
    language: "Sprache",
    selectLanguage: "Sprache auswählen",
    chooseLanguage: "Wählen Sie Ihre bevorzugte Sprache",
    project: "Projekt",
    selectProject: "Projekt auswählen",
    yourName: "Ihr Name",
    yourEmail: "Ihre E-Mail",
    videoLanguage: "Video-Sprache",
    countryRecorded: "Land, in dem das Video aufgenommen wurde",
    selectFiles: "Dateien auswählen",
    enterFullName: "Geben Sie Ihren vollständigen Namen ein",
    enterEmail: "Geben Sie Ihre E-Mail-Adresse ein",
    selectLanguageOption: "-- Sprache auswählen --",
    selectCountryOption: "-- Land auswählen --",
    selectProjectOption: "-- Projekt auswählen --",
    uploadAllFiles: "ALLE Dateien hochladen",
    uploading: "Wird hochgeladen...",
    retry: "Wiederholen",
    clearAll: "Alle löschen",
    chooseFiles: "Wählen Sie Ihre Dateien",
    selectFilesToShare: "Wählen Sie die Dateien aus, die Sie teilen möchten",
    uploadGuidelines: "Upload-Richtlinien:",
    maxFileSize: "Maximale Dateigröße: 10 GB",
    supportedFormats: "Unterstützte Formate:",
    secureStorage: "Ihre Dateien werden sicher in unserer Cloud gespeichert",
    stayOnPage: "Bitte bleiben Sie während des Upload-Vorgangs auf der Seite",
    
    // Drag and drop
    dragDropFiles: "Dateien hierher ziehen und ablegen",
    orClickToSelect: "oder klicken Sie, um Dateien auszuwählen",
    dropFilesHere: "Dateien hier ablegen...",
    authorizationTitle: "Autorisierungs- und Freigabeinformationen",
    authorizationText: "Ich verstehe, dass meine eingereichten Fotos/Videos (der \"Inhalt\") öffentlich im Namen von INCRUISES INTERNATIONAL, LLC (nachfolgend \"Das Unternehmen\" genannt) im Zusammenhang mit der Veröffentlichung und Förderung des Unternehmens verwendet werden können. Ich autorisiere Das Unternehmen, meinen Namen, kurze biografische Informationen und den Inhalt, wie in diesem Formular definiert, zu verwenden. Hiermit autorisiere ich Das Unternehmen unwiderruflich, den Inhalt zum Zwecke der Veröffentlichung der Programme des Unternehmens oder für jeden anderen rechtmäßigen Zweck zu kopieren, auszustellen, zu veröffentlichen oder zu verteilen. Diese Aussagen können in gedruckten Publikationen, Multimedia-Präsentationen, auf Websites oder in jedem anderen Verbreitungsmedium verwendet werden. Ich stimme ferner zu, dass ich keine monetären oder sonstigen Ansprüche gegen Das Unternehmen für die Verwendung des Inhalts geltend machen werde. Darüber hinaus verzichte ich auf jedes Recht, das fertige Produkt, einschließlich des geschriebenen Textes, zu überprüfen oder zu genehmigen, in dem mein Name, mein Bildnis oder der Inhalt erscheint. Hiermit stelle ich Das Unternehmen von allen Ansprüchen, Forderungen und Klagegründen frei, die ich, meine Erben, Vertreter, Testamentsvollstrecker, Verwalter oder andere Personen, die in meinem Namen oder im Namen meines Nachlasses handeln, haben oder haben könnten, aufgrund dieser Autorisierung.",
    consentCheckbox: "Ich habe die Autorisierungs- und Freigabeinformationen gelesen und gebe meine Zustimmung für die Verwendung wie oben angegeben.",
    nameRequired: "Name ist erforderlich",
    nameMinLength: "Name muss mindestens 2 Zeichen lang sein",
    nameMaxLength: "Name muss weniger als 100 Zeichen lang sein",
    nameInvalidChars: "Name darf nur Buchstaben, Leerzeichen, Bindestriche und Apostrophe enthalten",
    emailRequired: "E-Mail ist erforderlich",
    emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    emailTooLong: "E-Mail-Adresse ist zu lang",
    projectRequired: "Bitte wählen Sie ein Projekt aus.",
    consentRequired: "Bitte lesen und akzeptieren Sie die Autorisierungs- und Freigabeinformationen.",
    fillName: "Bitte geben Sie einen gültigen Namen ein, um die Dateiauswahl zu aktivieren.",
    fillEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein, um die Dateiauswahl zu aktivieren.",
    selectProjectRequired: "Bitte wählen Sie ein Projekt aus, um die Dateiauswahl zu aktivieren.",
    acceptConsent: "Bitte lesen und akzeptieren Sie die oben genannten Autorisierungs- und Freigabeinformationen, um die Dateiauswahl zu aktivieren.",
    fillNameAndEmail: "Bitte geben Sie einen gültigen Namen und eine gültige E-Mail-Adresse ein, um die Dateiauswahl zu aktivieren.",
    selectProjectAndConsent: "Bitte wählen Sie ein Projekt aus und akzeptieren Sie die Autorisierungs- und Freigabeinformationen, um die Dateiauswahl zu aktivieren.",
    selectProjectAndFill: "Bitte wählen Sie ein Projekt aus und geben Sie ein gültiges {field} ein, um die Dateiauswahl zu aktivieren.",
    fillAndConsent: "Bitte geben Sie ein gültiges {field} ein und akzeptieren Sie die Autorisierungs- und Freigabeinformationen, um die Dateiauswahl zu aktivieren.",
    allRequired: "Bitte wählen Sie ein Projekt aus, füllen Sie alle erforderlichen Felder (Name, E-Mail) mit gültigen Informationen aus und akzeptieren Sie die Autorisierungs- und Freigabeinformationen, um die Dateiauswahl zu aktivieren.",
    uploadsHistory: "Upload-Verlauf",
    initializing: "Wird initialisiert",
    ready: "Bereit",
    queued: "In Warteschlange",
    uploadingStatus: "Wird hochgeladen",
    paused: "Pausiert",
    completed: "Abgeschlossen",
    cancelled: "Abgebrochen",
    error: "Fehler",
    loadingProjects: "Projekte werden geladen...",
    failedToLoadProjects: "Projekte konnten nicht geladen werden.",
    cannotConnect: "Keine Verbindung zum Server möglich. Bitte stellen Sie sicher, dass der Server läuft.",
    uploadingForProject: "Sie werden Dateien für das Projekt hochladen",
    projectLabel: ".",
    cannotChangeProject: "Projekt kann nicht geändert werden. Bitte laden Sie alle Dateien für das aktuelle Projekt hoch, brechen Sie ab oder löschen Sie sie zuerst.",
    required: "*",
    upload: "Hochladen",
    resume: "Fortsetzen",
    pause: "Pausieren",
    cancel: "Abbrechen",
    current: "(Aktuell)",
    errorLabel: "Fehler:",
    removeFromList: "Aus Upload-Liste entfernen",
    dismissError: "Fehler verwerfen",
    readyForUploading: "bereit zum Hochladen",
    videoFiles: "Videodateien",
    audioFiles: "Audiodateien",
    imageFiles: "Bilddateien",
    documents: "Dokumente",
    archiveFiles: "Archivdateien",
    rawOtherFormats: "Roh-/Andere Formate",
    completionThankYou: "Vielen Dank für Ihre Einreichung!",
    completionFailedIntro: "Die folgenden Dateien konnten nicht hochgeladen werden:",
    completionUploadMore: "Weitere hochladen",

    // Footer
    followUs: "FOLGEN SIE UNS AUF",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© 2015 bis Gegenwart inGroup International. Alle Rechte vorbehalten.",

    // Video tip
    videoTipMessage: "Lesen Sie diesen Leitfaden für Tipps zum Filmen von Videos mit einem Smartphone:",
    videoTipLinkText: "LEITFADEN",
  },
  
  fr: {
    language: "Langue",
    selectLanguage: "Sélectionner la langue",
    chooseLanguage: "Choisissez votre langue préférée",
    project: "Projet",
    selectProject: "Sélectionner le projet",
    yourName: "Votre nom",
    yourEmail: "Votre e-mail",
    videoLanguage: "Langue de la vidéo",
    countryRecorded: "Pays où la vidéo a été enregistrée",
    selectFiles: "Sélectionner les fichiers",
    enterFullName: "Entrez votre nom complet",
    enterEmail: "Entrez votre adresse e-mail",
    selectLanguageOption: "-- Sélectionner la langue --",
    selectCountryOption: "-- Sélectionner le pays --",
    selectProjectOption: "-- Sélectionner un projet --",
    uploadAllFiles: "Télécharger TOUS les fichiers",
    uploading: "Téléchargement...",
    retry: "Réessayer",
    clearAll: "Tout effacer",
    chooseFiles: "Choisissez vos fichiers",
    selectFilesToShare: "Sélectionnez les fichiers que vous souhaitez partager",
    uploadGuidelines: "Directives de téléchargement:",
    maxFileSize: "Taille maximale du fichier: 10 Go",
    supportedFormats: "Formats pris en charge:",
    secureStorage: "Vos fichiers seront stockés en toute sécurité dans notre cloud",
    stayOnPage: "Veuillez rester sur la page pendant le processus de téléchargement",
    
    // Drag and drop
    dragDropFiles: "Glissez-déposez les fichiers ici",
    orClickToSelect: "ou cliquez pour sélectionner des fichiers",
    dropFilesHere: "Déposez les fichiers ici...",
    authorizationTitle: "Informations d'autorisation et de libération",
    authorizationText: "Je comprends que mes photos/vidéos soumises (le \"Contenu\") peuvent être utilisées publiquement au nom d'INCRUISES INTERNATIONAL, LLC (ci-après appelée \"L'Entreprise\") en relation avec la publicité et la promotion de L'Entreprise. J'autorise L'Entreprise à utiliser mon nom, de brèves informations biographiques et le Contenu tel que défini dans ce formulaire. Par la présente, j'autorise irrévocablement L'Entreprise à copier, exposer, publier ou distribuer le Contenu aux fins de publicité des programmes de L'Entreprise ou à toute autre fin légale. Ces déclarations peuvent être utilisées dans des publications imprimées, des présentations multimédias, sur des sites Web ou dans tout autre média de distribution. En outre, j'accepte de ne faire aucune réclamation monétaire ou autre contre L'Entreprise pour l'utilisation du Contenu. De plus, je renonce à tout droit d'inspecter ou d'approuver le produit fini, y compris le texte écrit, dans lequel mon nom, ma ressemblance ou le Contenu apparaît. Par la présente, je tiens L'Entreprise indemne et la libère de toutes réclamations, demandes et causes d'action que moi, mes héritiers, représentants, exécuteurs, administrateurs ou toute autre personne agissant en mon nom ou au nom de ma succession avons ou pouvons avoir en raison de cette autorisation.",
    consentCheckbox: "J'ai lu les informations d'autorisation et de libération et je donne mon consentement pour l'utilisation comme indiqué ci-dessus.",
    nameRequired: "Le nom est requis",
    nameMinLength: "Le nom doit contenir au moins 2 caractères",
    nameMaxLength: "Le nom doit contenir moins de 100 caractères",
    nameInvalidChars: "Le nom ne peut contenir que des lettres, des espaces, des tirets et des apostrophes",
    emailRequired: "L'e-mail est requis",
    emailInvalid: "Veuillez entrer une adresse e-mail valide",
    emailTooLong: "L'adresse e-mail est trop longue",
    projectRequired: "Veuillez sélectionner un projet.",
    consentRequired: "Veuillez lire et accepter les informations d'autorisation et de libération.",
    fillName: "Veuillez entrer un nom valide pour activer la sélection de fichiers.",
    fillEmail: "Veuillez entrer une adresse e-mail valide pour activer la sélection de fichiers.",
    selectProjectRequired: "Veuillez sélectionner un projet pour activer la sélection de fichiers.",
    acceptConsent: "Veuillez lire et accepter les informations d'autorisation et de libération ci-dessus pour activer la sélection de fichiers.",
    fillNameAndEmail: "Veuillez entrer un nom et une adresse e-mail valides pour activer la sélection de fichiers.",
    selectProjectAndConsent: "Veuillez sélectionner un projet et accepter les informations d'autorisation et de libération pour activer la sélection de fichiers.",
    selectProjectAndFill: "Veuillez sélectionner un projet et entrer un {field} valide pour activer la sélection de fichiers.",
    fillAndConsent: "Veuillez entrer un {field} valide et accepter les informations d'autorisation et de libération pour activer la sélection de fichiers.",
    allRequired: "Veuillez sélectionner un projet, remplir tous les champs requis (nom, e-mail) avec des informations valides et accepter les informations d'autorisation et de libération pour activer la sélection de fichiers.",
    uploadsHistory: "Historique des téléchargements",
    initializing: "Initialisation",
    ready: "Prêt",
    queued: "En file d'attente",
    uploadingStatus: "Téléchargement",
    paused: "En pause",
    completed: "Terminé",
    cancelled: "Annulé",
    error: "Erreur",
    loadingProjects: "Chargement des projets...",
    failedToLoadProjects: "Échec du chargement des projets.",
    cannotConnect: "Impossible de se connecter au serveur. Veuillez vous assurer que le serveur est en cours d'exécution.",
    uploadingForProject: "Vous allez télécharger des fichiers pour le projet",
    projectLabel: ".",
    cannotChangeProject: "Impossible de changer de projet. Veuillez télécharger, annuler ou supprimer tous les fichiers du projet actuel d'abord.",
    required: "*",
    upload: "Télécharger",
    resume: "Reprendre",
    pause: "Pause",
    cancel: "Annuler",
    current: "(Actuel)",
    errorLabel: "Erreur:",
    removeFromList: "Retirer de la liste de téléchargement",
    dismissError: "Ignorer l'erreur",
    readyForUploading: "prêt pour le téléchargement",
    videoFiles: "Fichiers vidéo",
    audioFiles: "Fichiers audio",
    imageFiles: "Fichiers image",
    documents: "Documents",
    archiveFiles: "Fichiers d'archive",
    rawOtherFormats: "Formats bruts/autres",
    completionThankYou: "Merci pour votre soumission !",
    completionFailedIntro: "Les fichiers suivants n'ont pas pu être téléchargés :",
    completionUploadMore: "Télécharger plus",

    // Footer
    followUs: "SUIVEZ-NOUS SUR",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© 2015 à Aujourd'hui inGroup International. Tous droits réservés.",

    // Video tip
    videoTipMessage: "Consultez ce guide pour des conseils pour filmer des vidéos avec un smartphone :",
    videoTipLinkText: "GUIDE",
  },
  
  // Add more languages as needed - I'll add a few key ones and you can expand
  it: {
    language: "Lingua",
    selectLanguage: "Seleziona lingua",
    chooseLanguage: "Scegli la tua lingua preferita",
    project: "Progetto",
    selectProject: "Seleziona progetto",
    yourName: "Il tuo nome",
    yourEmail: "La tua email",
    videoLanguage: "Lingua del video",
    countryRecorded: "Paese in cui è stato registrato il video",
    selectFiles: "Seleziona file",
    enterFullName: "Inserisci il tuo nome completo",
    enterEmail: "Inserisci il tuo indirizzo email",
    selectLanguageOption: "-- Seleziona lingua --",
    selectCountryOption: "-- Seleziona paese --",
    selectProjectOption: "-- Seleziona un progetto --",
    uploadAllFiles: "Carica TUTTI i file",
    uploading: "Caricamento...",
    retry: "Riprova",
    clearAll: "Cancella tutto",
    chooseFiles: "Scegli i tuoi file",
    selectFilesToShare: "Seleziona i file che vuoi condividere",
    uploadGuidelines: "Linee guida per il caricamento:",
    maxFileSize: "Dimensione massima del file: 10 GB",
    supportedFormats: "Formati supportati:",
    secureStorage: "I tuoi file saranno archiviati in modo sicuro nel nostro cloud",
    stayOnPage: "Rimani sulla pagina durante il processo di caricamento",
    
    // Drag and drop
    dragDropFiles: "Trascina e rilascia i file qui",
    orClickToSelect: "o fai clic per selezionare i file",
    dropFilesHere: "Rilascia i file qui...",
    authorizationTitle: "Informazioni su autorizzazione e liberatoria",
    authorizationText: "Comprendo che le mie foto/video inviati (il \"Contenuto\") possono essere utilizzati pubblicamente per conto di INCRUISES INTERNATIONAL, LLC (di seguito chiamata \"L'Azienda\") in relazione alla pubblicizzazione e promozione dell'Azienda. Autorizzo L'Azienda a utilizzare il mio nome, brevi informazioni biografiche e il Contenuto come definito in questo modulo. Con la presente autorizzo irrevocabilmente L'Azienda a copiare, esporre, pubblicare o distribuire il Contenuto ai fini della pubblicizzazione dei programmi dell'Azienda o per qualsiasi altro scopo legale. Queste dichiarazioni possono essere utilizzate in pubblicazioni stampate, presentazioni multimediali, su siti web o in qualsiasi altro mezzo di distribuzione. Inoltre, accetto di non avanzare alcuna richiesta monetaria o altra contro L'Azienda per l'uso del Contenuto. Inoltre, rinuncio a qualsiasi diritto di ispezionare o approvare il prodotto finito, incluso il testo scritto, in cui compaiono il mio nome, la mia somiglianza o il Contenuto. Con la presente tengo indenne e libero L'Azienda da tutte le richieste, domande e cause di azione che io, i miei eredi, rappresentanti, esecutori, amministratori o qualsiasi altra persona che agisca per mio conto o per conto della mia proprietà ho o posso avere a causa di questa autorizzazione.",
    consentCheckbox: "Ho letto le informazioni su autorizzazione e liberatoria e do il mio consenso per l'uso come indicato sopra.",
    nameRequired: "Il nome è obbligatorio",
    nameMinLength: "Il nome deve contenere almeno 2 caratteri",
    nameMaxLength: "Il nome deve contenere meno di 100 caratteri",
    nameInvalidChars: "Il nome può contenere solo lettere, spazi, trattini e apostrofi",
    emailRequired: "L'email è obbligatoria",
    emailInvalid: "Inserisci un indirizzo email valido",
    emailTooLong: "L'indirizzo email è troppo lungo",
    projectRequired: "Seleziona un progetto.",
    consentRequired: "Leggi e accetta le informazioni su autorizzazione e liberatoria.",
    fillName: "Inserisci un nome valido per abilitare la selezione dei file.",
    fillEmail: "Inserisci un indirizzo email valido per abilitare la selezione dei file.",
    selectProjectRequired: "Seleziona un progetto per abilitare la selezione dei file.",
    acceptConsent: "Leggi e accetta le informazioni su autorizzazione e liberatoria sopra per abilitare la selezione dei file.",
    fillNameAndEmail: "Inserisci un nome e un indirizzo email validi per abilitare la selezione dei file.",
    selectProjectAndConsent: "Seleziona un progetto e accetta le informazioni su autorizzazione e liberatoria per abilitare la selezione dei file.",
    selectProjectAndFill: "Seleziona un progetto e inserisci un {field} valido per abilitare la selezione dei file.",
    fillAndConsent: "Inserisci un {field} valido e accetta le informazioni su autorizzazione e liberatoria per abilitare la selezione dei file.",
    allRequired: "Seleziona un progetto, compila tutti i campi obbligatori (nome, email) con informazioni valide e accetta le informazioni su autorizzazione e liberatoria per abilitare la selezione dei file.",
    uploadsHistory: "Cronologia caricamenti",
    initializing: "Inizializzazione",
    ready: "Pronto",
    queued: "In coda",
    uploadingStatus: "Caricamento",
    paused: "In pausa",
    completed: "Completato",
    cancelled: "Annullato",
    error: "Errore",
    loadingProjects: "Caricamento progetti...",
    failedToLoadProjects: "Impossibile caricare i progetti.",
    cannotConnect: "Impossibile connettersi al server. Assicurati che il server sia in esecuzione.",
    uploadingForProject: "Caricherai file per il progetto",
    projectLabel: ".",
    cannotChangeProject: "Impossibile cambiare progetto. Carica, annulla o elimina tutti i file del progetto corrente prima.",
    required: "*",
    upload: "Carica",
    resume: "Riprendi",
    pause: "Pausa",
    cancel: "Annulla",
    current: "(Attuale)",
    errorLabel: "Errore:",
    removeFromList: "Rimuovi dalla lista di caricamento",
    dismissError: "Ignora errore",
    readyForUploading: "pronto per il caricamento",
    videoFiles: "File video",
    audioFiles: "File audio",
    imageFiles: "File immagine",
    documents: "Documenti",
    archiveFiles: "File archivio",
    rawOtherFormats: "Formati raw/altri",
    completionThankYou: "Grazie per il tuo invio!",
    completionFailedIntro: "I seguenti file non sono stati caricati:",
    completionUploadMore: "Carica altri",

    // Footer
    followUs: "SEGUICI SU",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© 2015 ad oggi inGroup International. Tutti i diritti riservati.",

    // Video tip
    videoTipMessage: "Consulta questa guida per suggerimenti su come filmare video con uno smartphone:",
    videoTipLinkText: "GUIDA",
  },
  
  // I'll add a few more key languages, but due to length, I'll create a helper to generate the rest
  // For now, let me add Russian, Spanish, and a couple others
  ru: {
    language: "Язык",
    selectLanguage: "Выберите язык",
    chooseLanguage: "Выберите предпочитаемый язык",
    project: "Проект",
    selectProject: "Выберите проект",
    yourName: "Ваше имя",
    yourEmail: "Ваш email",
    videoLanguage: "Язык видео",
    countryRecorded: "Страна, где было записано видео",
    selectFiles: "Выберите файлы",
    enterFullName: "Введите ваше полное имя",
    enterEmail: "Введите ваш email адрес",
    selectLanguageOption: "-- Выберите язык --",
    selectCountryOption: "-- Выберите страну --",
    selectProjectOption: "-- Выберите проект --",
    uploadAllFiles: "Загрузить ВСЕ файлы",
    uploading: "Загрузка...",
    retry: "Повторить",
    clearAll: "Очистить все",
    chooseFiles: "Выберите ваши файлы",
    selectFilesToShare: "Выберите файлы, которые хотите поделиться",
    uploadGuidelines: "Руководство по загрузке:",
    maxFileSize: "Максимальный размер файла: 10 ГБ",
    supportedFormats: "Поддерживаемые форматы:",
    secureStorage: "Ваши файлы будут безопасно храниться в нашем облаке",
    stayOnPage: "Пожалуйста, оставайтесь на странице во время процесса загрузки",
    
    // Drag and drop
    dragDropFiles: "Перетащите файлы сюда",
    orClickToSelect: "или нажмите, чтобы выбрать файлы",
    dropFilesHere: "Отпустите файлы здесь...",
    authorizationTitle: "Информация об авторизации и освобождении",
    authorizationText: "Я понимаю, что мои отправленные фотографии/видео (\"Контент\") могут быть публично использованы от имени INCRUISES INTERNATIONAL, LLC (далее именуемая \"Компания\") в связи с рекламой и продвижением Компании. Я разрешаю Компании использовать мое имя, краткую биографическую информацию и Контент, как определено в этой форме. Настоящим я безотзывно разрешаю Компании копировать, демонстрировать, публиковать или распространять Контент для целей рекламы программ Компании или для любых других законных целей. Эти заявления могут быть использованы в печатных изданиях, мультимедийных презентациях, на веб-сайтах или в любых других средствах распространения. Кроме того, я согласен, что не буду предъявлять никаких денежных или иных претензий к Компании за использование Контента. Кроме того, я отказываюсь от любого права проверять или одобрять готовый продукт, включая письменный текст, в котором появляется мое имя, изображение или Контент. Настоящим я освобождаю и освобождаю Компанию от всех претензий, требований и оснований для иска, которые я, мои наследники, представители, исполнители, администраторы или любые другие лица, действующие от моего имени или от имени моего имущества, имею или могу иметь в связи с этим разрешением.",
    consentCheckbox: "Я прочитал информацию об авторизации и освобождении и даю свое согласие на использование, как указано выше.",
    nameRequired: "Имя обязательно",
    nameMinLength: "Имя должно содержать не менее 2 символов",
    nameMaxLength: "Имя должно содержать менее 100 символов",
    nameInvalidChars: "Имя может содержать только буквы, пробелы, дефисы и апострофы",
    emailRequired: "Email обязателен",
    emailInvalid: "Пожалуйста, введите действительный email адрес",
    emailTooLong: "Email адрес слишком длинный",
    projectRequired: "Пожалуйста, выберите проект.",
    consentRequired: "Пожалуйста, прочитайте и примите информацию об авторизации и освобождении.",
    fillName: "Пожалуйста, введите действительное имя для включения выбора файлов.",
    fillEmail: "Пожалуйста, введите действительный email для включения выбора файлов.",
    selectProjectRequired: "Пожалуйста, выберите проект для включения выбора файлов.",
    acceptConsent: "Пожалуйста, прочитайте и примите информацию об авторизации и освобождении выше для включения выбора файлов.",
    fillNameAndEmail: "Пожалуйста, введите действительное имя и email для включения выбора файлов.",
    selectProjectAndConsent: "Пожалуйста, выберите проект и примите информацию об авторизации и освобождении для включения выбора файлов.",
    selectProjectAndFill: "Пожалуйста, выберите проект и введите действительный {field} для включения выбора файлов.",
    fillAndConsent: "Пожалуйста, введите действительный {field} и примите информацию об авторизации и освобождении для включения выбора файлов.",
    allRequired: "Пожалуйста, выберите проект, заполните все обязательные поля (имя, email) действительной информацией и примите информацию об авторизации и освобождении для включения выбора файлов.",
    uploadsHistory: "История загрузок",
    initializing: "Инициализация",
    ready: "Готов",
    queued: "В очереди",
    uploadingStatus: "Загрузка",
    paused: "Приостановлено",
    completed: "Завершено",
    cancelled: "Отменено",
    error: "Ошибка",
    loadingProjects: "Загрузка проектов...",
    failedToLoadProjects: "Не удалось загрузить проекты.",
    cannotConnect: "Невозможно подключиться к серверу. Пожалуйста, убедитесь, что сервер запущен.",
    uploadingForProject: "Вы будете загружать файлы для проекта",
    projectLabel: ".",
    cannotChangeProject: "Невозможно изменить проект. Пожалуйста, сначала загрузите, отмените или удалите все файлы текущего проекта.",
    required: "*",
    upload: "Загрузить",
    resume: "Возобновить",
    pause: "Приостановить",
    cancel: "Отменить",
    current: "(Текущий)",
    errorLabel: "Ошибка:",
    removeFromList: "Удалить из списка загрузок",
    dismissError: "Закрыть ошибку",
    readyForUploading: "готов к загрузке",
    videoFiles: "Видеофайлы",
    audioFiles: "Аудиофайлы",
    imageFiles: "Файлы изображений",
    documents: "Документы",
    archiveFiles: "Архивные файлы",
    rawOtherFormats: "Сырые/Другие форматы",

    // Completion modal
    completionThankYou: "Спасибо за вашу отправку!",
    completionFailedIntro: "Следующие файлы не удалось загрузить:",
    completionUploadMore: "Загрузить ещё",

    // Footer
    followUs: "ПОДПИСЫВАЙТЕСЬ НА НАС",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© С 2015 по настоящее время. inGroup International. Все права защищены.",

    // Video tip
    videoTipMessage: "Ознакомьтесь с советами по съёмке видео на смартфон:",
    videoTipLinkText: "РУКОВОДСТВО",
  },
  
  es: {
    language: "Idioma",
    selectLanguage: "Seleccionar idioma",
    chooseLanguage: "Elija su idioma preferido",
    project: "Proyecto",
    selectProject: "Seleccionar proyecto",
    yourName: "Su nombre",
    yourEmail: "Su correo electrónico",
    videoLanguage: "Idioma del video",
    countryRecorded: "País donde se grabó el video",
    selectFiles: "Seleccionar archivos",
    enterFullName: "Ingrese su nombre completo",
    enterEmail: "Ingrese su dirección de correo electrónico",
    selectLanguageOption: "-- Seleccionar idioma --",
    selectCountryOption: "-- Seleccionar país --",
    selectProjectOption: "-- Seleccionar un proyecto --",
    uploadAllFiles: "Subir TODOS los archivos",
    uploading: "Subiendo...",
    retry: "Reintentar",
    clearAll: "Limpiar todo",
    chooseFiles: "Elija sus archivos",
    selectFilesToShare: "Seleccione los archivos que desea compartir",
    uploadGuidelines: "Directrices de carga:",
    maxFileSize: "Tamaño máximo de archivo: 10 GB",
    supportedFormats: "Formatos compatibles:",
    secureStorage: "Sus archivos se almacenarán de forma segura en nuestra nube",
    stayOnPage: "Por favor, permanezca en la página durante el proceso de carga",
    
    // Drag and drop
    dragDropFiles: "Arrastre y suelte los archivos aquí",
    orClickToSelect: "o haga clic para seleccionar archivos",
    dropFilesHere: "Suelte los archivos aquí...",
    authorizationTitle: "Información de autorización y liberación",
    authorizationText: "Entiendo que mis fotos/videos enviados (el \"Contenido\") pueden ser utilizados públicamente en nombre de INCRUISES INTERNATIONAL, LLC (en adelante llamada \"La Empresa\") en relación con la publicidad y promoción de La Empresa. Autorizo a La Empresa a usar mi nombre, información biográfica breve y el Contenido según se define en este formulario. Por la presente autorizo irrevocablemente a La Empresa a copiar, exhibir, publicar o distribuir el Contenido con el fin de publicitar los programas de La Empresa o para cualquier otro propósito legal. Estas declaraciones pueden ser utilizadas en publicaciones impresas, presentaciones multimedia, en sitios web o en cualquier otro medio de distribución. Además, acepto que no haré ninguna reclamación monetaria ni de otro tipo contra La Empresa por el uso del Contenido. Además, renuncio a cualquier derecho a inspeccionar o aprobar el producto terminado, incluido el texto escrito, en el que aparezcan mi nombre, mi imagen o el Contenido. Por la presente, eximo y libero a La Empresa de todas las reclamaciones, demandas y causas de acción que yo, mis herederos, representantes, ejecutores, administradores o cualquier otra persona que actúe en mi nombre o en nombre de mi patrimonio tenga o pueda tener en razón de esta autorización.",
    consentCheckbox: "He leído la información de autorización y liberación y doy mi consentimiento para el uso como se indica arriba.",
    nameRequired: "El nombre es obligatorio",
    nameMinLength: "El nombre debe tener al menos 2 caracteres",
    nameMaxLength: "El nombre debe tener menos de 100 caracteres",
    nameInvalidChars: "El nombre solo puede contener letras, espacios, guiones y apostrofes",
    emailRequired: "El correo electrónico es obligatorio",
    emailInvalid: "Por favor, ingrese una dirección de correo electrónico válida",
    emailTooLong: "La dirección de correo electrónico es demasiado larga",
    projectRequired: "Por favor, seleccione un proyecto.",
    consentRequired: "Por favor, lea y acepte la información de autorización y liberación.",
    fillName: "Por favor, ingrese un nombre válido para habilitar la selección de archivos.",
    fillEmail: "Por favor, ingrese un correo electrónico válido para habilitar la selección de archivos.",
    selectProjectRequired: "Por favor, seleccione un proyecto para habilitar la selección de archivos.",
    acceptConsent: "Por favor, lea y acepte la información de autorización y liberación anterior para habilitar la selección de archivos.",
    fillNameAndEmail: "Por favor, ingrese un nombre y correo electrónico válidos para habilitar la selección de archivos.",
    selectProjectAndConsent: "Por favor, seleccione un proyecto y acepte la información de autorización y liberación para habilitar la selección de archivos.",
    selectProjectAndFill: "Por favor, seleccione un proyecto e ingrese un {field} válido para habilitar la selección de archivos.",
    fillAndConsent: "Por favor, ingrese un {field} válido y acepte la información de autorización y liberación para habilitar la selección de archivos.",
    allRequired: "Por favor, seleccione un proyecto, complete todos los campos obligatorios (nombre, correo electrónico) con información válida y acepte la información de autorización y liberación para habilitar la selección de archivos.",
    uploadsHistory: "Historial de cargas",
    initializing: "Inicializando",
    ready: "Listo",
    queued: "En cola",
    uploadingStatus: "Subiendo",
    paused: "Pausado",
    completed: "Completado",
    cancelled: "Cancelado",
    error: "Error",
    loadingProjects: "Cargando proyectos...",
    failedToLoadProjects: "Error al cargar los proyectos.",
    cannotConnect: "No se puede conectar al servidor. Por favor, asegúrese de que el servidor esté en ejecución.",
    uploadingForProject: "Va a cargar archivos para el proyecto",
    projectLabel: ".",
    cannotChangeProject: "No se puede cambiar el proyecto. Por favor, cargue, cancele o elimine todos los archivos del proyecto actual primero.",
    required: "*",
    upload: "Subir",
    resume: "Reanudar",
    pause: "Pausar",
    cancel: "Cancelar",
    current: "(Actual)",
    errorLabel: "Error:",
    removeFromList: "Eliminar de la lista de cargas",
    dismissError: "Descartar error",
    readyForUploading: "listo para cargar",
    videoFiles: "Archivos de video",
    audioFiles: "Archivos de audio",
    imageFiles: "Archivos de imagen",
    documents: "Documentos",
    archiveFiles: "Archivos de archivo",
    rawOtherFormats: "Formatos raw/otros",
    completionThankYou: "Gracias por su envio!",
    completionFailedIntro: "Los siguientes archivos no se pudieron cargar:",
    completionUploadMore: "Subir mas",

    // Footer
    followUs: "SÍGUENOS EN",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© 2015 a la actualidad inGroup International. Todos los derechos reservados.",

    // Video tip
    videoTipMessage: "Consulta esta guía para consejos sobre cómo grabar videos con un smartphone:",
    videoTipLinkText: "GUÍA",
  },
  
  // Japanese
  ja: {
    language: "言語",
    selectLanguage: "言語を選択",
    chooseLanguage: "希望する言語を選択してください",
    project: "プロジェクト",
    selectProject: "プロジェクトを選択",
    yourName: "お名前",
    yourEmail: "メールアドレス",
    videoLanguage: "動画の言語",
    countryRecorded: "動画が録画された国",
    selectFiles: "ファイルを選択",
    enterFullName: "フルネームを入力",
    enterEmail: "メールアドレスを入力",
    selectLanguageOption: "-- 言語を選択 --",
    selectCountryOption: "-- 国を選択 --",
    selectProjectOption: "-- プロジェクトを選択 --",
    uploadAllFiles: "すべてのファイルをアップロード",
    uploading: "アップロード中...",
    retry: "再試行",
    clearAll: "すべてクリア",
    chooseFiles: "ファイルを選択",
    selectFilesToShare: "共有したいファイルを選択",
    uploadGuidelines: "アップロードガイドライン:",
    maxFileSize: "最大ファイルサイズ: 10 GB",
    supportedFormats: "サポートされている形式:",
    secureStorage: "ファイルはクラウドに安全に保存されます",
    stayOnPage: "アップロード中はページに留まってください",
    
    // Drag and drop
    dragDropFiles: "ファイルをここにドラッグ＆ドロップ",
    orClickToSelect: "またはクリックしてファイルを選択",
    dropFilesHere: "ファイルをここにドロップ...",
    authorizationTitle: "承認およびリリース情報",
    authorizationText: "提出した写真/動画（「コンテンツ」）が、INCRUISES INTERNATIONAL, LLC（以下「会社」）の代わりに、会社の宣伝およびプロモーションに関連して公開使用される可能性があることを理解しています。私は、会社がこのフォームで定義されているように、私の名前、簡単な経歴情報、およびコンテンツを使用することを承認します。本件により、私は会社が会社のプログラムを宣伝する目的、またはその他の合法的な目的のためにコンテンツをコピー、展示、公開、または配布することを不可逆的に承認します。これらの声明は、印刷物、マルチメディアプレゼンテーション、ウェブサイト、またはその他の配信メディアで使用される場合があります。さらに、コンテンツの使用について会社に対して金銭的またはその他の請求を行わないことに同意します。さらに、私の名前、肖像、またはコンテンツが表示される完成品（書面を含む）を検査または承認する権利を放棄します。本件により、私、私の相続人、代表者、執行者、管理者、または私の代理または私の財産の代理として行動するその他の人物が、この承認により有する、または有する可能性のあるすべての請求、要求、および訴訟原因から会社を無害に保ち、解放します。",
    consentCheckbox: "承認およびリリース情報を読み、上記に示されている使用について同意します。",
    nameRequired: "名前は必須です",
    nameMinLength: "名前は少なくとも2文字である必要があります",
    nameMaxLength: "名前は100文字未満である必要があります",
    nameInvalidChars: "名前には文字、スペース、ハイフン、アポストロフィのみを含めることができます",
    emailRequired: "メールアドレスは必須です",
    emailInvalid: "有効なメールアドレスを入力してください",
    emailTooLong: "メールアドレスが長すぎます",
    projectRequired: "プロジェクトを選択してください。",
    consentRequired: "承認およびリリース情報を読み、承認してください。",
    fillName: "ファイル選択を有効にするには、有効な名前を入力してください。",
    fillEmail: "ファイル選択を有効にするには、有効なメールアドレスを入力してください。",
    selectProjectRequired: "ファイル選択を有効にするには、プロジェクトを選択してください。",
    acceptConsent: "ファイル選択を有効にするには、上記の承認およびリリース情報を読み、承認してください。",
    fillNameAndEmail: "ファイル選択を有効にするには、有効な名前とメールアドレスを入力してください。",
    selectProjectAndConsent: "ファイル選択を有効にするには、プロジェクトを選択し、承認およびリリース情報を承認してください。",
    selectProjectAndFill: "ファイル選択を有効にするには、プロジェクトを選択し、有効な{field}を入力してください。",
    fillAndConsent: "ファイル選択を有効にするには、有効な{field}を入力し、承認およびリリース情報を承認してください。",
    allRequired: "ファイル選択を有効にするには、プロジェクトを選択し、すべての必須フィールド（名前、メールアドレス）に有効な情報を入力し、承認およびリリース情報を承認してください。",
    uploadsHistory: "アップロード履歴",
    initializing: "初期化中",
    ready: "準備完了",
    queued: "待機中",
    uploadingStatus: "アップロード中",
    paused: "一時停止",
    completed: "完了",
    cancelled: "キャンセル",
    error: "エラー",
    loadingProjects: "プロジェクトを読み込み中...",
    failedToLoadProjects: "プロジェクトの読み込みに失敗しました。",
    cannotConnect: "サーバーに接続できません。サーバーが実行されていることを確認してください。",
    uploadingForProject: "プロジェクトにファイルをアップロードします",
    projectLabel: "。",
    cannotChangeProject: "プロジェクトを変更できません。現在のプロジェクトのすべてのファイルをアップロード、キャンセル、または削除してから実行してください。",
    required: "*",
    upload: "アップロード",
    resume: "再開",
    pause: "一時停止",
    cancel: "キャンセル",
    current: "（現在）",
    errorLabel: "エラー:",
    removeFromList: "アップロードリストから削除",
    dismissError: "エラーを閉じる",
    readyForUploading: "アップロード準備完了",
    videoFiles: "動画ファイル",
    audioFiles: "音声ファイル",
    imageFiles: "画像ファイル",
    documents: "ドキュメント",
    archiveFiles: "アーカイブファイル",
    rawOtherFormats: "RAW/その他の形式",
    completionThankYou: "ご提出ありがとうございます！",
    completionFailedIntro: "以下のファイルのアップロードに失敗しました：",
    completionUploadMore: "さらにアップロード",

    // Footer
    followUs: "フォローしよう",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© 2015年〜現在 inGroup International、全権保有。",

    // Video tip
    videoTipMessage: "スマートフォンでの動画撮影のヒントについては、こちらのガイドをご覧ください：",
    videoTipLinkText: "ガイド",
  },
  
  // Kazakh
  kk: {
    language: "Тіл",
    selectLanguage: "Тілді таңдаңыз",
    chooseLanguage: "Қалаған тіліңізді таңдаңыз",
    project: "Жоба",
    selectProject: "Жобаны таңдаңыз",
    yourName: "Атыңыз",
    yourEmail: "Электрондық поштаңыз",
    videoLanguage: "Бейне тілі",
    countryRecorded: "Бейне жазылған елі",
    selectFiles: "Файлдарды таңдаңыз",
    enterFullName: "Толық атыңызды енгізіңіз",
    enterEmail: "Электрондық пошта мекенжайыңызды енгізіңіз",
    selectLanguageOption: "-- Тілді таңдаңыз --",
    selectCountryOption: "-- Елді таңдаңыз --",
    selectProjectOption: "-- Жобаны таңдаңыз --",
    uploadAllFiles: "БАРЛЫҚ файлдарды жүктеу",
    uploading: "Жүктелуде...",
    retry: "Қайталау",
    clearAll: "Барлығын тазалау",
    chooseFiles: "Файлдарыңызды таңдаңыз",
    selectFilesToShare: "Бөліскіңіз келетін файлдарды таңдаңыз",
    uploadGuidelines: "Жүктеу нұсқаулары:",
    maxFileSize: "Максималды файл өлшемі: 10 ГБ",
    supportedFormats: "Қолдау көрсетілетін форматтар:",
    secureStorage: "Файлдарыңыз біздің бұлтта қауіпсіз сақталады",
    stayOnPage: "Жүктеу процесі кезінде бетте қалған жөн",
    
    // Drag and drop
    dragDropFiles: "Файлдарды осы жерге сүйреп тастаңыз",
    orClickToSelect: "немесе файлдарды таңдау үшін басыңыз",
    dropFilesHere: "Файлдарды осы жерге тастаңыз...",
    authorizationTitle: "Авторизация және босату ақпараты",
    authorizationText: "Мен жіберген фото/бейнелерімнің (\"Мазмұн\") INCRUISES INTERNATIONAL, LLC (бұдан былай \"Компания\" деп аталады) атынан Компанияны жарнамалау және алға шығаруға байланысты қоғамдық пайдаланылуы мүмкін екенін түсінемін. Мен Компанияға осы формада анықталғандай менің атым, қысқа биографиялық ақпаратым және Мазмұнды пайдалануға рұқсат беремін. Осы арқылы мен Компанияның бағдарламаларын жарнамалау мақсатында немесе кез келген басқа заңды мақсат үшін Мазмұнды көшіруге, көрсетуге, жариялауға немесе таратуға қайтымсыз рұқсат беремін. Бұл мәлімдемелер басылымдарда, мультимедиа презентацияларында, веб-сайттарда немесе кез келген басқа тарату құралдарында пайдаланылуы мүмкін. Сонымен қатар, мен Мазмұнды пайдалану үшін Компанияға қарсы ақшалай немесе басқа да талаптар енгізбейтініме келісемін. Сонымен қатар, менің атым, суретім немесе Мазмұн пайда болған аяқталған өнімді, соның ішінде жазбаша мәтінді тексеруге немесе бекітуге құқығымнан бас тартамын. Осы арқылы мен Компанияны мен, менің мұрагерлерім, өкілдерім, орындаушылар, әкімшілер немесе менің атымнан немесе менің мүлкімнің атынан әрекет ететін кез келген басқа адамдар осы авторизацияға байланысты бар немесе болуы мүмкін барлық талаптардан, сұраулардан және іс қозғау себептерінен босатамын және босатамын.",
    consentCheckbox: "Мен авторизация және босату ақпаратын оқыдым және жоғарыда көрсетілгендей пайдалануға келісім беремін.",
    nameRequired: "Аты талап етіледі",
    nameMinLength: "Аты кемінде 2 таңбадан тұруы керек",
    nameMaxLength: "Аты 100 таңбадан аз болуы керек",
    nameInvalidChars: "Аты тек әріптер, бос орындар, дефис және апострофтарды қамтуы мүмкін",
    emailRequired: "Электрондық пошта талап етіледі",
    emailInvalid: "Жарамды электрондық пошта мекенжайын енгізіңіз",
    emailTooLong: "Электрондық пошта мекенжайы тым ұзын",
    projectRequired: "Жобаны таңдаңыз.",
    consentRequired: "Авторизация және босату ақпаратын оқып, қабылдаңыз.",
    fillName: "Файл таңдауды іске қосу үшін жарамды аты енгізіңіз.",
    fillEmail: "Файл таңдауды іске қосу үшін жарамды электрондық пошта енгізіңіз.",
    selectProjectRequired: "Файл таңдауды іске қосу үшін жобаны таңдаңыз.",
    acceptConsent: "Файл таңдауды іске қосу үшін жоғарыдағы авторизация және босату ақпаратын оқып, қабылдаңыз.",
    fillNameAndEmail: "Файл таңдауды іске қосу үшін жарамды аты мен электрондық поштаны енгізіңіз.",
    selectProjectAndConsent: "Файл таңдауды іске қосу үшін жобаны таңдап, авторизация және босату ақпаратын қабылдаңыз.",
    selectProjectAndFill: "Файл таңдауды іске қосу үшін жобаны таңдап, жарамды {field} енгізіңіз.",
    fillAndConsent: "Файл таңдауды іске қосу үшін жарамды {field} енгізіп, авторизация және босату ақпаратын қабылдаңыз.",
    allRequired: "Файл таңдауды іске қосу үшін жобаны таңдаңыз, барлық міндетті өрістерге (аты, электрондық пошта) жарамды ақпарат енгізіңіз және авторизация және босату ақпаратын қабылдаңыз.",
    uploadsHistory: "Жүктеу тарихы",
    initializing: "Бастау",
    ready: "Дайын",
    queued: "Кезекте",
    uploadingStatus: "Жүктелуде",
    paused: "Кідіртілген",
    completed: "Аяқталды",
    cancelled: "Бас тартылды",
    error: "Қате",
    loadingProjects: "Жобалар жүктелуде...",
    failedToLoadProjects: "Жобаларды жүктеу сәтсіз аяқталды.",
    cannotConnect: "Серверге қосылу мүмкін емес. Сервердің жұмыс істеп тұрғанына көз жеткізіңіз.",
    uploadingForProject: "Жобаға файлдарды жүктейсіз",
    projectLabel: ".",
    cannotChangeProject: "Жобаны өзгерту мүмкін емес. Алдымен ағымдағы жобаның барлық файлдарын жүктеңіз, бас тартыңыз немесе жойыңыз.",
    required: "*",
    upload: "Жүктеу",
    resume: "Жалғастыру",
    pause: "Кідірту",
    cancel: "Бас тарту",
    current: "(Ағымдағы)",
    errorLabel: "Қате:",
    removeFromList: "Жүктеу тізімінен жою",
    dismissError: "Қатені жабу",
    readyForUploading: "жүктеуге дайын",
    videoFiles: "Бейне файлдары",
    audioFiles: "Аудио файлдары",
    imageFiles: "Сурет файлдары",
    documents: "Құжаттар",
    archiveFiles: "Архив файлдары",
    rawOtherFormats: "Raw/Басқа форматтар",
    completionThankYou: "Жібергеніңіз үшін рахмет!",
    completionFailedIntro: "Келесі файлдарды жүктеу сәтсіз аяқталды:",
    completionUploadMore: "Тағы жүктеу",

    // Footer
    followUs: "БІЗГЕ ЖАЗЫЛЫҢЫЗ",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© 2015 жылдан бастап қазіргі уақытқа дейін inGroup International. Барлық құқықтар қорғалған.",

    // Video tip
    videoTipMessage: "Смартфонмен бейне түсіру бойынша кеңестер үшін осы нұсқаулықты қараңыз:",
    videoTipLinkText: "НҰСҚАУЛЫҚ",
  },
  
  // Korean
  ko: {
    language: "언어",
    selectLanguage: "언어 선택",
    chooseLanguage: "선호하는 언어를 선택하세요",
    project: "프로젝트",
    selectProject: "프로젝트 선택",
    yourName: "이름",
    yourEmail: "이메일",
    videoLanguage: "동영상 언어",
    countryRecorded: "동영상이 녹화된 국가",
    selectFiles: "파일 선택",
    enterFullName: "전체 이름을 입력하세요",
    enterEmail: "이메일 주소를 입력하세요",
    selectLanguageOption: "-- 언어 선택 --",
    selectCountryOption: "-- 국가 선택 --",
    selectProjectOption: "-- 프로젝트 선택 --",
    uploadAllFiles: "모든 파일 업로드",
    uploading: "업로드 중...",
    retry: "다시 시도",
    clearAll: "모두 지우기",
    chooseFiles: "파일 선택",
    selectFilesToShare: "공유할 파일을 선택하세요",
    uploadGuidelines: "업로드 가이드라인:",
    maxFileSize: "최대 파일 크기: 10 GB",
    supportedFormats: "지원 형식:",
    secureStorage: "파일이 클라우드에 안전하게 저장됩니다",
    stayOnPage: "업로드 과정 중 페이지에 머물러 주세요",
    
    // Drag and drop
    dragDropFiles: "파일을 여기로 끌어다 놓으세요",
    orClickToSelect: "또는 클릭하여 파일 선택",
    dropFilesHere: "파일을 여기에 놓으세요...",
    authorizationTitle: "승인 및 해제 정보",
    authorizationText: "제출한 사진/동영상(\"콘텐츠\")이 INCRUISES INTERNATIONAL, LLC(이하 \"회사\")를 대신하여 회사의 홍보 및 프로모션과 관련하여 공개적으로 사용될 수 있음을 이해합니다. 저는 회사가 이 양식에 정의된 대로 제 이름, 간단한 전기 정보 및 콘텐츠를 사용하도록 승인합니다. 본인은 회사가 회사의 프로그램을 홍보하거나 기타 합법적인 목적을 위해 콘텐츠를 복사, 전시, 게시 또는 배포할 수 있도록 불가역적으로 승인합니다. 이러한 진술은 인쇄 출판물, 멀티미디어 프레젠테이션, 웹사이트 또는 기타 배포 미디어에서 사용될 수 있습니다. 또한 콘텐츠 사용에 대해 회사에 대한 금전적 또는 기타 청구를 하지 않기로 동의합니다. 또한 제 이름, 초상 또는 콘텐츠가 나타나는 완성된 제품(서면 포함)을 검사하거나 승인할 권리를 포기합니다. 본인은 이 승인으로 인해 본인, 본인의 상속인, 대리인, 집행자, 관리자 또는 본인을 대신하거나 본인의 재산을 대신하여 행동하는 기타 사람이 가질 수 있거나 가질 수 있는 모든 청구, 요구 및 소송 원인으로부터 회사를 면책하고 해제합니다.",
    consentCheckbox: "승인 및 해제 정보를 읽었으며 위에 명시된 대로 사용에 동의합니다.",
    nameRequired: "이름은 필수입니다",
    nameMinLength: "이름은 최소 2자 이상이어야 합니다",
    nameMaxLength: "이름은 100자 미만이어야 합니다",
    nameInvalidChars: "이름에는 문자, 공백, 하이픈 및 아포스트로피만 포함할 수 있습니다",
    emailRequired: "이메일은 필수입니다",
    emailInvalid: "유효한 이메일 주소를 입력하세요",
    emailTooLong: "이메일 주소가 너무 깁니다",
    projectRequired: "프로젝트를 선택하세요.",
    consentRequired: "승인 및 해제 정보를 읽고 동의하세요.",
    fillName: "파일 선택을 활성화하려면 유효한 이름을 입력하세요.",
    fillEmail: "파일 선택을 활성화하려면 유효한 이메일을 입력하세요.",
    selectProjectRequired: "파일 선택을 활성화하려면 프로젝트를 선택하세요.",
    acceptConsent: "파일 선택을 활성화하려면 위의 승인 및 해제 정보를 읽고 동의하세요.",
    fillNameAndEmail: "파일 선택을 활성화하려면 유효한 이름과 이메일을 입력하세요.",
    selectProjectAndConsent: "파일 선택을 활성화하려면 프로젝트를 선택하고 승인 및 해제 정보에 동의하세요.",
    selectProjectAndFill: "파일 선택을 활성화하려면 프로젝트를 선택하고 유효한 {field}를 입력하세요.",
    fillAndConsent: "파일 선택을 활성화하려면 유효한 {field}를 입력하고 승인 및 해제 정보에 동의하세요.",
    allRequired: "파일 선택을 활성화하려면 프로젝트를 선택하고 모든 필수 필드(이름, 이메일)에 유효한 정보를 입력하고 승인 및 해제 정보에 동의하세요.",
    uploadsHistory: "업로드 기록",
    initializing: "초기화 중",
    ready: "준비됨",
    queued: "대기 중",
    uploadingStatus: "업로드 중",
    paused: "일시 중지됨",
    completed: "완료됨",
    cancelled: "취소됨",
    error: "오류",
    loadingProjects: "프로젝트 로드 중...",
    failedToLoadProjects: "프로젝트를 로드하지 못했습니다.",
    cannotConnect: "서버에 연결할 수 없습니다. 서버가 실행 중인지 확인하세요.",
    uploadingForProject: "프로젝트에 파일을 업로드합니다",
    projectLabel: ".",
    cannotChangeProject: "프로젝트를 변경할 수 없습니다. 먼저 현재 프로젝트의 모든 파일을 업로드, 취소 또는 삭제하세요.",
    required: "*",
    upload: "업로드",
    resume: "재개",
    pause: "일시 중지",
    cancel: "취소",
    current: "(현재)",
    errorLabel: "오류:",
    removeFromList: "업로드 목록에서 제거",
    dismissError: "오류 닫기",
    readyForUploading: "업로드 준비됨",
    videoFiles: "동영상 파일",
    audioFiles: "오디오 파일",
    imageFiles: "이미지 파일",
    documents: "문서",
    archiveFiles: "아카이브 파일",
    rawOtherFormats: "RAW/기타 형식",
    completionThankYou: "제출해 주셔서 감사합니다!",
    completionFailedIntro: "다음 파일을 업로드하지 못했습니다:",
    completionUploadMore: "더 업로드",

    // Footer
    followUs: "우리를 팔로우하세요",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705 (푸에르토리코)",
    footerCopyright: "© 2015년부터 현재까지 inGroup International. 판권 소유.",

    // Video tip
    videoTipMessage: "스마트폰으로 동영상을 촬영하는 팁은 이 가이드를 확인하세요:",
    videoTipLinkText: "가이드",
  },
  
  // Kyrgyz
  ky: {
    language: "Тил",
    selectLanguage: "Тилди тандаңыз",
    chooseLanguage: "Каалаган тилиңизди тандаңыз",
    project: "Долбоор",
    selectProject: "Долбоорду тандаңыз",
    yourName: "Атыңыз",
    yourEmail: "Электрондук почтаңыз",
    videoLanguage: "Видео тили",
    countryRecorded: "Видео жазылган өлкө",
    selectFiles: "Файлдарды тандаңыз",
    enterFullName: "Толук атыңызды киргизиңиз",
    enterEmail: "Электрондук почта дарегиңизди киргизиңиз",
    selectLanguageOption: "-- Тилди тандаңыз --",
    selectCountryOption: "-- Өлкөнү тандаңыз --",
    selectProjectOption: "-- Долбоорду тандаңыз --",
    uploadAllFiles: "БААРЫ файлдарды жүктөө",
    uploading: "Жүктөлүүдө...",
    retry: "Кайталоо",
    clearAll: "Баарын тазалоо",
    chooseFiles: "Файлдарыңызды тандаңыз",
    selectFilesToShare: "Бөлүшкүңүз келген файлдарды тандаңыз",
    uploadGuidelines: "Жүктөө көрсөтмөлөрү:",
    maxFileSize: "Максималдуу файл көлөмү: 10 ГБ",
    supportedFormats: "Колдоо көрсөтүлгөн форматтар:",
    secureStorage: "Файлдарыңыз биздин булутта коопсуз сакталат",
    stayOnPage: "Жүктөө процессинде бетте калган жөн",
    
    // Drag and drop
    dragDropFiles: "Файлдарды бул жерге сүйрөп таштаңыз",
    orClickToSelect: "же файлдарды тандаш үчүн басыңыз",
    dropFilesHere: "Файлдарды бул жерге таштаңыз...",
    authorizationTitle: "Авторизация жана бошотуу маалыматы",
    authorizationText: "Мен жөнөткөн фото/видеолорумдун (\"Мазмун\") INCRUISES INTERNATIONAL, LLC (булдан бери \"Компания\" деп аталат) атынан Компанияны жарнамалоо жана алга чыгарууга байланыштуу коомдук пайдаланылышы мүмкүн экенин түшүнөм. Мен Компанияга ушул формада аныкталгандай менин атым, кыска биографиялык маалыматым жана Мазмунду пайдаланууга уруксат берем. Ушул аркылуу мен Компаниянын программаларын жарнамалоо максатында же каалаган башка мыйзамдуу максат үчүн Мазмунду көчүрүүгө, көрсөтүүгө, жарыялоого же таратууга кайтымсыз уруксат берем. Бул маалыматтар басылмаларда, мультимедиа презентацияларында, веб-сайттарда же каалаган башка таратуу куралдарында пайдаланылышы мүмкүн. Ошондой эле, мен Мазмунду пайдалануу үчүн Компанияга каршы акчалай же башка талаптар киргизбейтиниме келишем. Ошондой эле, менин атым, сүрөтүм же Мазмун пайда болгон аякталган өнүмдү, анын ичинде жазуу матенин текшерүүгө же бекитүүгө укугумдан баш тартамын. Ушул аркылуу мен Компанияны мен, менин мурагерлерим, өкүлдөрүм, аткаруучулар, башкаруучулар же менин атымдан же менин мулкүмдүн атынан арекет кылган каалаган башка адамдар ушул авторизацияга байланыштуу бар же болушу мүмкүн бардык талаптардан, суроолордон жана иш козгоо себептеринен бошотом жана бошотом.",
    consentCheckbox: "Мен авторизация жана бошотуу маалыматын окудум жана жогоруда көрсөтүлгөндөй пайдаланууга келишим берем.",
    nameRequired: "Аты талап кылынат",
    nameMinLength: "Аты кеминде 2 тамгадан туруу керек",
    nameMaxLength: "Аты 100 тамгадан аз болушу керек",
    nameInvalidChars: "Аты тек тамгалар, бош орундар, дефис жана апострофтарды камтышы мүмкүн",
    emailRequired: "Электрондук почта талап кылынат",
    emailInvalid: "Жарактуу электрондук почта дарегин киргизиңиз",
    emailTooLong: "Электрондук почта дареги өтө узун",
    projectRequired: "Долбоорду тандаңыз.",
    consentRequired: "Авторизация жана бошотуу маалыматын окуп, кабылдаңыз.",
    fillName: "Файл тандауду иштетүү үчүн жарактуу аты киргизиңиз.",
    fillEmail: "Файл тандауду иштетүү үчүн жарактуу электрондук почта киргизиңиз.",
    selectProjectRequired: "Файл тандауду иштетүү үчүн долбоорду тандаңыз.",
    acceptConsent: "Файл тандауду иштетүү үчүн жогорудагы авторизация жана бошотуу маалыматын окуп, кабылдаңыз.",
    fillNameAndEmail: "Файл тандауду иштетүү үчүн жарактуу аты менен электрондук почтаны киргизиңиз.",
    selectProjectAndConsent: "Файл тандауду иштетүү үчүн долбоорду тандап, авторизация жана бошотуу маалыматын кабылдаңыз.",
    selectProjectAndFill: "Файл тандауду иштетүү үчүн долбоорду тандап, жарактуу {field} киргизиңиз.",
    fillAndConsent: "Файл тандауду иштетүү үчүн жарактуу {field} киргизип, авторизация жана бошотуу маалыматын кабылдаңыз.",
    allRequired: "Файл тандауду иштетүү үчүн долбоорду тандаңыз, бардык милдеттүү талааларга (аты, электрондук почта) жарактуу маалымат киргизиңиз жана авторизация жана бошотуу маалыматын кабылдаңыз.",
    uploadsHistory: "Жүктөө тарыхы",
    initializing: "Башталуу",
    ready: "Даяр",
    queued: "Кезекте",
    uploadingStatus: "Жүктөлүүдө",
    paused: "Токтотулган",
    completed: "Аякталды",
    cancelled: "Жокко чыгарылды",
    error: "Ката",
    loadingProjects: "Долбоорлор жүктөлүүдө...",
    failedToLoadProjects: "Долбоорлорду жүктөө ийгиликсиз аяктады.",
    cannotConnect: "Серверге туташуу мүмкүн эмес. Сервердин иштеп турганына көз жеткириңиз.",
    uploadingForProject: "Долбоорго файлдарды жүктөйсүз",
    projectLabel: ".",
    cannotChangeProject: "Долбоорду өзгөртүү мүмкүн эмес. Алгач азыркы долбоордун бардык файлдарын жүктөңүз, жокко чыгарыңыз же жок кылыңыз.",
    required: "*",
    upload: "Жүктөө",
    resume: "Улантуу",
    pause: "Токтотуу",
    cancel: "Жокко чыгаруу",
    current: "(Азыркы)",
    errorLabel: "Ката:",
    removeFromList: "Жүктөө тизмесинен жок кылуу",
    dismissError: "Катаны жабуу",
    readyForUploading: "жүктөөгө даяр",
    videoFiles: "Видео файлдары",
    audioFiles: "Аудио файлдары",
    imageFiles: "Сүрөт файлдары",
    documents: "Документтер",
    archiveFiles: "Архив файлдары",
    rawOtherFormats: "Raw/Башка форматтар",
    completionThankYou: "Жөнөткөнүңүз үчүн рахмат!",
    completionFailedIntro: "Төмөнкү файлдарды жүктөө ийгиликсиз аяктады:",
    completionUploadMore: "Дагы жүктөө",

    // Footer
    followUs: "БИЗГЕ КАТТАЛЫҢЫЗ",
    footerAddress: "St. 1- Лот №3, Сьют 500 (Metro Office Park 3) Гуаянабо, Пуэрто-Рико 00968-1705",
    footerCopyright: "© 2015-жылдан бүгүнкү күнгө чейин inGroup International. Бардык укуктар корголгон.",

    // Video tip
    videoTipMessage: "Смартфон менен видео тартуу боюнча кеңештер үчүн бул колдонмону караңыз:",
    videoTipLinkText: "КОЛДОНМО",
  },
  
  // Latvian
  lv: {
    language: "Valoda",
    selectLanguage: "Izvēlieties valodu",
    chooseLanguage: "Izvēlieties vēlamo valodu",
    project: "Projekts",
    selectProject: "Izvēlieties projektu",
    yourName: "Jūsu vārds",
    yourEmail: "Jūsu e-pasts",
    videoLanguage: "Video valoda",
    countryRecorded: "Valsts, kurā video tika ierakstīts",
    selectFiles: "Izvēlieties failus",
    enterFullName: "Ievadiet savu pilno vārdu",
    enterEmail: "Ievadiet savu e-pasta adresi",
    selectLanguageOption: "-- Izvēlieties valodu --",
    selectCountryOption: "-- Izvēlieties valsti --",
    selectProjectOption: "-- Izvēlieties projektu --",
    uploadAllFiles: "Augšupielādēt VISUS failus",
    uploading: "Augšupielādē...",
    retry: "Mēģināt vēlreiz",
    clearAll: "Notīrīt visu",
    chooseFiles: "Izvēlieties savus failus",
    selectFilesToShare: "Izvēlieties failus, kurus vēlaties dalīties",
    uploadGuidelines: "Augšupielādes vadlīnijas:",
    maxFileSize: "Maksimālais faila izmērs: 10 GB",
    supportedFormats: "Atbalstītie formāti:",
    secureStorage: "Jūsu faili tiks droši glabāti mūsu mākonī",
    stayOnPage: "Lūdzu, palieciet lapā augšupielādes procesa laikā",
    
    // Drag and drop
    dragDropFiles: "Velciet un nometiet failus šeit",
    orClickToSelect: "vai noklikšķiniet, lai atlasītu failus",
    dropFilesHere: "Nometiet failus šeit...",
    authorizationTitle: "Autorizācijas un atbrīvošanas informācija",
    authorizationText: "Es saprotu, ka manas iesniegtās fotogrāfijas/video (\"Saturs\") var tikt publiski izmantotas INCRUISES INTERNATIONAL, LLC (turpmāk saukta par \"Uzņēmums\") vārdā saistībā ar Uzņēmuma reklamēšanu un popularizēšanu. Es autorizēju Uzņēmumam izmantot manu vārdu, īsu biogrāfisko informāciju un Saturu, kā definēts šajā formā. Ar šo es neatgriezeniski autorizēju Uzņēmumam kopēt, izstādīt, publicēt vai izplatīt Saturu Uzņēmuma programmu reklamēšanas nolūkos vai jebkādiem citiem likumīgiem mērķiem. Šie apgalvojumi var tikt izmantoti drukātās publikācijās, multivides prezentācijās, tīmekļa vietnēs vai jebkādos citos izplatīšanas medijos. Turklāt es piekrītu, ka neveikšu nekādus naudas vai citus prasījumus pret Uzņēmumu par Satura izmantošanu. Turklāt es atteicos no jebkādas tiesības pārbaudīt vai apstiprināt gatavo produktu, ieskaitot rakstīto tekstu, kurā parādās mans vārds, tēls vai Saturs. Ar šo es atbrīvoju un atbrīvoju Uzņēmumu no visām prasībām, pieprasījumiem un ierosināšanas iemesliem, kas man, maniem mantiniekiem, pārstāvjiem, izpildītājiem, administratoriem vai jebkādām citām personām, kas rīkojas manā vārdā vai manas mantas vārdā, ir vai var būt šīs autorizācijas dēļ.",
    consentCheckbox: "Es esmu izlasījis autorizācijas un atbrīvošanas informāciju un sniedzu savu piekrišanu izmantošanai, kā norādīts iepriekš.",
    nameRequired: "Vārds ir obligāts",
    nameMinLength: "Vārdam jābūt vismaz 2 rakstzīmēm",
    nameMaxLength: "Vārdam jābūt mazāk nekā 100 rakstzīmēm",
    nameInvalidChars: "Vārds var saturēt tikai burtus, atstarpes, defisus un apostrofus",
    emailRequired: "E-pasts ir obligāts",
    emailInvalid: "Lūdzu, ievadiet derīgu e-pasta adresi",
    emailTooLong: "E-pasta adrese ir pārāk gara",
    projectRequired: "Lūdzu, izvēlieties projektu.",
    consentRequired: "Lūdzu, izlasiet un pieņemiet autorizācijas un atbrīvošanas informāciju.",
    fillName: "Lūdzu, ievadiet derīgu vārdu, lai aktivizētu failu izvēli.",
    fillEmail: "Lūdzu, ievadiet derīgu e-pastu, lai aktivizētu failu izvēli.",
    selectProjectRequired: "Lūdzu, izvēlieties projektu, lai aktivizētu failu izvēli.",
    acceptConsent: "Lūdzu, izlasiet un pieņemiet iepriekš minēto autorizācijas un atbrīvošanas informāciju, lai aktivizētu failu izvēli.",
    fillNameAndEmail: "Lūdzu, ievadiet derīgu vārdu un e-pastu, lai aktivizētu failu izvēli.",
    selectProjectAndConsent: "Lūdzu, izvēlieties projektu un pieņemiet autorizācijas un atbrīvošanas informāciju, lai aktivizētu failu izvēli.",
    selectProjectAndFill: "Lūdzu, izvēlieties projektu un ievadiet derīgu {field}, lai aktivizētu failu izvēli.",
    fillAndConsent: "Lūdzu, ievadiet derīgu {field} un pieņemiet autorizācijas un atbrīvošanas informāciju, lai aktivizētu failu izvēli.",
    allRequired: "Lūdzu, izvēlieties projektu, aizpildiet visus obligātos laukus (vārds, e-pasts) ar derīgu informāciju un pieņemiet autorizācijas un atbrīvošanas informāciju, lai aktivizētu failu izvēli.",
    uploadsHistory: "Augšupielādes vēsture",
    initializing: "Inicializēšana",
    ready: "Gatavs",
    queued: "Rindā",
    uploadingStatus: "Augšupielādē",
    paused: "Pauzēts",
    completed: "Pabeigts",
    cancelled: "Atcelts",
    error: "Kļūda",
    loadingProjects: "Projekti tiek ielādēti...",
    failedToLoadProjects: "Neizdevās ielādēt projektus.",
    cannotConnect: "Nevar izveidot savienojumu ar serveri. Lūdzu, pārliecinieties, ka serveris darbojas.",
    uploadingForProject: "Jūs augšupielādēsit failus projektam",
    projectLabel: ".",
    cannotChangeProject: "Nevar mainīt projektu. Lūdzu, vispirms augšupielādējiet, atceliet vai izdzēsiet visus pašreizējā projekta failus.",
    required: "*",
    upload: "Augšupielādēt",
    resume: "Turpināt",
    pause: "Pauzēt",
    cancel: "Atcelt",
    current: "(Pašreizējais)",
    errorLabel: "Kļūda:",
    removeFromList: "Noņemt no augšupielādes saraksta",
    dismissError: "Aizvērt kļūdu",
    readyForUploading: "gatavs augšupielādei",
    videoFiles: "Video faili",
    audioFiles: "Audio faili",
    imageFiles: "Attēlu faili",
    documents: "Dokumenti",
    archiveFiles: "Arhīva faili",
    rawOtherFormats: "Raw/Citi formāti",
    completionThankYou: "Paldies par jūsu iesniegumu!",
    completionFailedIntro: "Šādus failus neizdevās augšupielādēt:",
    completionUploadMore: "Augšupielādēt vairāk",

    // Footer
    followUs: "SEKO MUMS LĪDZI",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro biroja Parks 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© No 2015.gada īdz šodienai inGroup International. Visas tiesības aizsargātas.",

    // Video tip
    videoTipMessage: "Iepazīstieties ar šo rokasgrāmatu, lai uzzinātu padomus video filmēšanai ar viedtālruni:",
    videoTipLinkText: "ROKASGRĀMATA",
  },
  
  // Mongolian
  mn: {
    language: "Хэл",
    selectLanguage: "Хэл сонгох",
    chooseLanguage: "Хүссэн хэлээ сонгоно уу",
    project: "Төсөл",
    selectProject: "Төслийг сонгох",
    yourName: "Таны нэр",
    yourEmail: "Таны имэйл",
    videoLanguage: "Видео хэл",
    countryRecorded: "Видео бичлэг хийсэн улс",
    selectFiles: "Файл сонгох",
    enterFullName: "Бүтэн нэрээ оруулна уу",
    enterEmail: "Имэйл хаягаа оруулна уу",
    selectLanguageOption: "-- Хэл сонгох --",
    selectCountryOption: "-- Улс сонгох --",
    selectProjectOption: "-- Төсөл сонгох --",
    uploadAllFiles: "БҮХ файлыг байршуулах",
    uploading: "Байршуулж байна...",
    retry: "Дахин оролдох",
    clearAll: "Бүгдийг цэвэрлэх",
    chooseFiles: "Файлуудаа сонгоно уу",
    selectFilesToShare: "Хуваалцах файлуудаа сонгоно уу",
    uploadGuidelines: "Байршуулах заавар:",
    maxFileSize: "Хамгийн их файлын хэмжээ: 10 GB",
    supportedFormats: "Дэмжигдсэн формат:",
    secureStorage: "Таны файлууд манай үүлэнд аюулгүй хадгалагдана",
    stayOnPage: "Байршуулах явцад хуудсан дээр үлдэнэ үү",
    
    // Drag and drop
    dragDropFiles: "Файлуудыг энд чирж тавина уу",
    orClickToSelect: "эсвэл файл сонгохын тулд дарна уу",
    dropFilesHere: "Файлуудыг энд тавина уу...",
    authorizationTitle: "Зөвшөөрөл ба чөлөөлөх мэдээлэл",
    authorizationText: "Би илгээсэн зураг/видеонууд (\"Агуулга\") INCRUISES INTERNATIONAL, LLC (цаашид \"Компани\" гэх) нэрийн өмнөөс Компанийн сурталчилгаа, дэмжлэгтэй холбоотойгоор олон нийтэд ашиглах боломжтой гэдгийг ойлгож байна. Би Компанид энэхүү маягтад тодорхойлсон байдлаар миний нэр, товч намтар мэдээлэл болон Агуулгыг ашиглахыг зөвшөөрч байна. Энэхүү байдлаар би Компанийн хөтөлбөрүүдийг сурталчилах эсвэл бусад хууль ёсны зорилгоор Агуулгыг хуулбарлах, үзүүлэх, хэвлэх эсвэл түгээхэд Компанид эргэлт буцалтгүй зөвшөөрч байна. Эдгээр мэдэгдлүүдийг хэвлэмэл хэвлэлд, олон медиа танилцуулгад, вэбсайтууд эсвэл бусад түгээлтийн хэрэгслүүдэд ашиглаж болно. Цаашид би Агуулгыг ашигласны төлөө Компанид мөнгөн эсвэл бусад шаардлага тавихгүй гэдгээ хүлээн зөвшөөрч байна. Нэмж хэлэхэд, миний нэр, дүрс эсвэл Агуулга гарч ирсэн бэлэн бүтээгдэхүүнийг, үүнд бичсэн текстийг шалгах эсвэл баталгаажуулах эрхээсээ татгалзаж байна. Энэхүү байдлаар би энэхүү зөвшөөрлийн улмаас надад, миний өвлөгчдөд, төлөөлөгчдөд, гүйцэтгэгчдэд, удирдагчдад эсвэл миний нэрийн өмнөөс эсвэл миний өмчийн нэрийн өмнөөс үйлдэл хийх бусад хүмүүст байгаа эсвэл байж болох бүх шаардлага, хүсэлт, ажиллагааны шалтгаануудаас Компанийг хамгаалж, чөлөөлж байна.",
    consentCheckbox: "Би зөвшөөрөл ба чөлөөлөх мэдээллийг уншиж, дээр дурдсан байдлаар ашиглахыг зөвшөөрч байна.",
    nameRequired: "Нэр шаардлагатай",
    nameMinLength: "Нэр дор хаяж 2 тэмдэгт байх ёстой",
    nameMaxLength: "Нэр 100 тэмдэгтээс бага байх ёстой",
    nameInvalidChars: "Нэр зөвхөн үсэг, зай, зураас, апостроф агуулж болно",
    emailRequired: "Имэйл шаардлагатай",
    emailInvalid: "Зөв имэйл хаяг оруулна уу",
    emailTooLong: "Имэйл хаяг хэт урт байна",
    projectRequired: "Төслийг сонгоно уу.",
    consentRequired: "Зөвшөөрөл ба чөлөөлөх мэдээллийг уншаад хүлээн зөвшөөрнө үү.",
    fillName: "Файл сонгохыг идэвхжүүлэхийн тулд зөв нэр оруулна уу.",
    fillEmail: "Файл сонгохыг идэвхжүүлэхийн тулд зөв имэйл оруулна уу.",
    selectProjectRequired: "Файл сонгохыг идэвхжүүлэхийн тулд төслийг сонгоно уу.",
    acceptConsent: "Файл сонгохыг идэвхжүүлэхийн тулд дээрх зөвшөөрөл ба чөлөөлөх мэдээллийг уншаад хүлээн зөвшөөрнө үү.",
    fillNameAndEmail: "Файл сонгохыг идэвхжүүлэхийн тулд зөв нэр болон имэйл оруулна уу.",
    selectProjectAndConsent: "Файл сонгохыг идэвхжүүлэхийн тулд төслийг сонгож, зөвшөөрөл ба чөлөөлөх мэдээллийг хүлээн зөвшөөрнө үү.",
    selectProjectAndFill: "Файл сонгохыг идэвхжүүлэхийн тулд төслийг сонгож, зөв {field} оруулна уу.",
    fillAndConsent: "Файл сонгохыг идэвхжүүлэхийн тулд зөв {field} оруулж, зөвшөөрөл ба чөлөөлөх мэдээллийг хүлээн зөвшөөрнө үү.",
    allRequired: "Файл сонгохыг идэвхжүүлэхийн тулд төслийг сонгоно уу, бүх шаардлагатай талбарууд (нэр, имэйл) зөв мэдээллээр бөглөж, зөвшөөрөл ба чөлөөлөх мэдээллийг хүлээн зөвшөөрнө үү.",
    uploadsHistory: "Байршуулалтын түүх",
    initializing: "Эхлүүлэх",
    ready: "Бэлэн",
    queued: "Дараалалд",
    uploadingStatus: "Байршуулж байна",
    paused: "Зогссон",
    completed: "Дууссан",
    cancelled: "Цуцлагдсан",
    error: "Алдаа",
    loadingProjects: "Төслүүд ачааллаж байна...",
    failedToLoadProjects: "Төслүүдийг ачааллаж чадсангүй.",
    cannotConnect: "Сервертэй холбогдох боломжгүй. Сервер ажиллаж байгаа эсэхийг шалгана уу.",
    uploadingForProject: "Төсөлд файлуудыг байршуулах болно",
    projectLabel: ".",
    cannotChangeProject: "Төслийг өөрчлөх боломжгүй. Эхлээд одоогийн төслийн бүх файлуудыг байршуулж, цуцлаж эсвэл устгана уу.",
    required: "*",
    upload: "Байршуулах",
    resume: "Үргэлжлүүлэх",
    pause: "Зогсоох",
    cancel: "Цуцлах",
    current: "(Одоогийн)",
    errorLabel: "Алдаа:",
    removeFromList: "Байршуулалтын жагсаалтаас хасах",
    dismissError: "Алдааг хаах",
    readyForUploading: "байршуулахад бэлэн",
    videoFiles: "Видео файлууд",
    audioFiles: "Дууны файлууд",
    imageFiles: "Зургийн файлууд",
    documents: "Баримт бичиг",
    archiveFiles: "Архив файлууд",
    rawOtherFormats: "Түүхий/Бусад формат",
    completionThankYou: "Илгээсэнд баярлалаа!",
    completionFailedIntro: "Дараах файлуудыг байршуулж чадсангүй:",
    completionUploadMore: "Дахин байршуулах",

    // Footer
    followUs: "БИДНИЙГ ДАГААРАЙ",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© 2015 оноос хойш, inGroup International. Бүх эрх зохиогчийн эрхийн хуулиар хамгаалагдсан.",

    // Video tip
    videoTipMessage: "Ухаалаг утсаар видео бичлэг хийх зөвлөмжийг энэ гарын авлагаас үзнэ үү:",
    videoTipLinkText: "ГАРЫН АВЛАГА",
  },
  
  // Portuguese
  pt: {
    language: "Idioma",
    selectLanguage: "Selecionar idioma",
    chooseLanguage: "Escolha seu idioma preferido",
    project: "Projeto",
    selectProject: "Selecionar projeto",
    yourName: "Seu nome",
    yourEmail: "Seu e-mail",
    videoLanguage: "Idioma do vídeo",
    countryRecorded: "País onde o vídeo foi gravado",
    selectFiles: "Selecionar arquivos",
    enterFullName: "Digite seu nome completo",
    enterEmail: "Digite seu endereço de e-mail",
    selectLanguageOption: "-- Selecionar idioma --",
    selectCountryOption: "-- Selecionar país --",
    selectProjectOption: "-- Selecionar um projeto --",
    uploadAllFiles: "Enviar TODOS os arquivos",
    uploading: "Enviando...",
    retry: "Tentar novamente",
    clearAll: "Limpar tudo",
    chooseFiles: "Escolha seus arquivos",
    selectFilesToShare: "Selecione os arquivos que deseja compartilhar",
    uploadGuidelines: "Diretrizes de envio:",
    maxFileSize: "Tamanho máximo do arquivo: 10 GB",
    supportedFormats: "Formatos suportados:",
    secureStorage: "Seus arquivos serão armazenados com segurança em nossa nuvem",
    stayOnPage: "Por favor, permaneça na página durante o processo de envio",
    
    // Drag and drop
    dragDropFiles: "Arraste e solte os arquivos aqui",
    orClickToSelect: "ou clique para selecionar arquivos",
    dropFilesHere: "Solte os arquivos aqui...",
    authorizationTitle: "Informações de autorização e liberação",
    authorizationText: "Entendo que minhas fotos/vídeos enviados (o \"Conteúdo\") podem ser usados publicamente em nome da INCRUISES INTERNATIONAL, LLC (doravante chamada \"A Empresa\") em conexão com a publicidade e promoção da Empresa. Autorizo a Empresa a usar meu nome, informações biográficas breves e o Conteúdo conforme definido neste formulário. Por meio deste, autorizo irrevogavelmente a Empresa a copiar, exibir, publicar ou distribuir o Conteúdo para fins de publicidade dos programas da Empresa ou para qualquer outro propósito legal. Essas declarações podem ser usadas em publicações impressas, apresentações multimídia, em sites ou em qualquer outro meio de distribuição. Além disso, concordo que não farei nenhuma reivindicação monetária ou outra contra a Empresa pelo uso do Conteúdo. Além disso, renuncio a qualquer direito de inspecionar ou aprovar o produto final, incluindo texto escrito, no qual meu nome, semelhança ou Conteúdo apareça. Por meio deste, isento e libero a Empresa de todas as reivindicações, demandas e causas de ação que eu, meus herdeiros, representantes, executores, administradores ou quaisquer outras pessoas agindo em meu nome ou em nome da minha propriedade tenho ou posso ter em razão desta autorização.",
    consentCheckbox: "Li as informações de autorização e liberação e dou meu consentimento para o uso conforme indicado acima.",
    nameRequired: "Nome é obrigatório",
    nameMinLength: "O nome deve ter pelo menos 2 caracteres",
    nameMaxLength: "O nome deve ter menos de 100 caracteres",
    nameInvalidChars: "O nome pode conter apenas letras, espaços, hífens e apóstrofos",
    emailRequired: "E-mail é obrigatório",
    emailInvalid: "Por favor, insira um endereço de e-mail válido",
    emailTooLong: "O endereço de e-mail é muito longo",
    projectRequired: "Por favor, selecione um projeto.",
    consentRequired: "Por favor, leia e aceite as informações de autorização e liberação.",
    fillName: "Por favor, insira um nome válido para habilitar a seleção de arquivos.",
    fillEmail: "Por favor, insira um e-mail válido para habilitar a seleção de arquivos.",
    selectProjectRequired: "Por favor, selecione um projeto para habilitar a seleção de arquivos.",
    acceptConsent: "Por favor, leia e aceite as informações de autorização e liberação acima para habilitar a seleção de arquivos.",
    fillNameAndEmail: "Por favor, insira um nome e e-mail válidos para habilitar a seleção de arquivos.",
    selectProjectAndConsent: "Por favor, selecione um projeto e aceite as informações de autorização e liberação para habilitar a seleção de arquivos.",
    selectProjectAndFill: "Por favor, selecione um projeto e insira um {field} válido para habilitar a seleção de arquivos.",
    fillAndConsent: "Por favor, insira um {field} válido e aceite as informações de autorização e liberação para habilitar a seleção de arquivos.",
    allRequired: "Por favor, selecione um projeto, preencha todos os campos obrigatórios (nome, e-mail) com informações válidas e aceite as informações de autorização e liberação para habilitar a seleção de arquivos.",
    uploadsHistory: "Histórico de envios",
    initializing: "Inicializando",
    ready: "Pronto",
    queued: "Na fila",
    uploadingStatus: "Enviando",
    paused: "Pausado",
    completed: "Concluído",
    cancelled: "Cancelado",
    error: "Erro",
    loadingProjects: "Carregando projetos...",
    failedToLoadProjects: "Falha ao carregar projetos.",
    cannotConnect: "Não é possível conectar ao servidor. Por favor, certifique-se de que o servidor está em execução.",
    uploadingForProject: "Você enviará arquivos para o projeto",
    projectLabel: ".",
    cannotChangeProject: "Não é possível alterar o projeto. Por favor, envie, cancele ou exclua todos os arquivos do projeto atual primeiro.",
    required: "*",
    upload: "Enviar",
    resume: "Retomar",
    pause: "Pausar",
    cancel: "Cancelar",
    current: "(Atual)",
    errorLabel: "Erro:",
    removeFromList: "Remover da lista de envios",
    dismissError: "Descartar erro",
    readyForUploading: "pronto para envio",
    videoFiles: "Arquivos de vídeo",
    audioFiles: "Arquivos de áudio",
    imageFiles: "Arquivos de imagem",
    documents: "Documentos",
    archiveFiles: "Arquivos de arquivo",
    rawOtherFormats: "Formatos raw/outros",
    completionThankYou: "Obrigado pelo seu envio!",
    completionFailedIntro: "Os seguintes arquivos falharam ao ser enviados:",
    completionUploadMore: "Enviar mais",

    // Footer
    followUs: "SIGA-NOS NO",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© 2015 até o presente inGroup International. Todos os direitos reservados.",

    // Video tip
    videoTipMessage: "Confira este guia para dicas sobre como filmar vídeos com um smartphone:",
    videoTipLinkText: "GUIA",
  },
  
  // Romanian
  ro: {
    language: "Limbă",
    selectLanguage: "Selectați limba",
    chooseLanguage: "Alegeți limba preferată",
    project: "Proiect",
    selectProject: "Selectați proiectul",
    yourName: "Numele dvs.",
    yourEmail: "E-mailul dvs.",
    videoLanguage: "Limba videoclipului",
    countryRecorded: "Țara în care a fost înregistrat videoclipul",
    selectFiles: "Selectați fișiere",
    enterFullName: "Introduceți numele complet",
    enterEmail: "Introduceți adresa de e-mail",
    selectLanguageOption: "-- Selectați limba --",
    selectCountryOption: "-- Selectați țara --",
    selectProjectOption: "-- Selectați un proiect --",
    uploadAllFiles: "Încărcați TOATE fișierele",
    uploading: "Se încarcă...",
    retry: "Încercați din nou",
    clearAll: "Șterge tot",
    chooseFiles: "Alegeți fișierele",
    selectFilesToShare: "Selectați fișierele pe care doriți să le partajați",
    uploadGuidelines: "Ghiduri de încărcare:",
    maxFileSize: "Dimensiunea maximă a fișierului: 10 GB",
    supportedFormats: "Formate acceptate:",
    secureStorage: "Fișierele dvs. vor fi stocate în siguranță în cloud-ul nostru",
    stayOnPage: "Vă rugăm să rămâneți pe pagină în timpul procesului de încărcare",
    
    // Drag and drop
    dragDropFiles: "Trageți și plasați fișierele aici",
    orClickToSelect: "sau faceți clic pentru a selecta fișiere",
    dropFilesHere: "Plasați fișierele aici...",
    authorizationTitle: "Informații despre autorizare și eliberare",
    authorizationText: "Înțeleg că fotografiile/videoclipurile mele trimise (\"Conținutul\") pot fi folosite public în numele INCRUISES INTERNATIONAL, LLC (denumită în continuare \"Compania\") în legătură cu publicitatea și promovarea Companiei. Autorizez Compania să folosească numele meu, informații biografice scurte și Conținutul așa cum este definit în acest formular. Prin prezenta autorizez irevocabil Compania să copieze, să expună, să publice sau să distribuie Conținutul în scopul publicității programelor Companiei sau pentru orice alt scop legal. Aceste declarații pot fi folosite în publicații tipărite, prezentări multimedia, pe site-uri web sau în orice alt mediu de distribuție. De asemenea, sunt de acord că nu voi face nicio pretenție monetară sau altă pretenție împotriva Companiei pentru utilizarea Conținutului. În plus, renunț la orice drept de a inspecta sau aproba produsul finit, inclusiv textul scris, în care apare numele meu, asemănarea sau Conținutul. Prin prezenta scutesc și eliberez Compania de toate pretențiile, cererile și cauzele de acțiune pe care eu, moștenitorii mei, reprezentanții, executorii, administratorii sau orice alte persoane care acționează în numele meu sau în numele proprietății mele le am sau le pot avea din cauza acestei autorizări.",
    consentCheckbox: "Am citit informațiile despre autorizare și eliberare și îmi dau consimțământul pentru utilizare așa cum este indicat mai sus.",
    nameRequired: "Numele este obligatoriu",
    nameMinLength: "Numele trebuie să aibă cel puțin 2 caractere",
    nameMaxLength: "Numele trebuie să aibă mai puțin de 100 de caractere",
    nameInvalidChars: "Numele poate conține doar litere, spații, cratime și apostrofuri",
    emailRequired: "E-mailul este obligatoriu",
    emailInvalid: "Vă rugăm să introduceți o adresă de e-mail validă",
    emailTooLong: "Adresa de e-mail este prea lungă",
    projectRequired: "Vă rugăm să selectați un proiect.",
    consentRequired: "Vă rugăm să citiți și să acceptați informațiile despre autorizare și eliberare.",
    fillName: "Vă rugăm să introduceți un nume valid pentru a activa selecția fișierelor.",
    fillEmail: "Vă rugăm să introduceți un e-mail valid pentru a activa selecția fișierelor.",
    selectProjectRequired: "Vă rugăm să selectați un proiect pentru a activa selecția fișierelor.",
    acceptConsent: "Vă rugăm să citiți și să acceptați informațiile despre autorizare și eliberare de mai sus pentru a activa selecția fișierelor.",
    fillNameAndEmail: "Vă rugăm să introduceți un nume și un e-mail valide pentru a activa selecția fișierelor.",
    selectProjectAndConsent: "Vă rugăm să selectați un proiect și să acceptați informațiile despre autorizare și eliberare pentru a activa selecția fișierelor.",
    selectProjectAndFill: "Vă rugăm să selectați un proiect și să introduceți un {field} valid pentru a activa selecția fișierelor.",
    fillAndConsent: "Vă rugăm să introduceți un {field} valid și să acceptați informațiile despre autorizare și eliberare pentru a activa selecția fișierelor.",
    allRequired: "Vă rugăm să selectați un proiect, să completați toate câmpurile obligatorii (nume, e-mail) cu informații valide și să acceptați informațiile despre autorizare și eliberare pentru a activa selecția fișierelor.",
    uploadsHistory: "Istoricul încărcărilor",
    initializing: "Inițializare",
    ready: "Gata",
    queued: "În coadă",
    uploadingStatus: "Se încarcă",
    paused: "Pauzat",
    completed: "Finalizat",
    cancelled: "Anulat",
    error: "Eroare",
    loadingProjects: "Se încarcă proiectele...",
    failedToLoadProjects: "Nu s-au putut încărca proiectele.",
    cannotConnect: "Nu se poate conecta la server. Vă rugăm să vă asigurați că serverul rulează.",
    uploadingForProject: "Veți încărca fișiere pentru proiectul",
    projectLabel: ".",
    cannotChangeProject: "Nu se poate schimba proiectul. Vă rugăm să încărcați, să anulați sau să ștergeți mai întâi toate fișierele proiectului curent.",
    required: "*",
    upload: "Încărca",
    resume: "Relua",
    pause: "Pauză",
    cancel: "Anulează",
    current: "(Actual)",
    errorLabel: "Eroare:",
    removeFromList: "Elimină din lista de încărcări",
    dismissError: "Închide eroarea",
    readyForUploading: "gata pentru încărcare",
    videoFiles: "Fișiere video",
    audioFiles: "Fișiere audio",
    imageFiles: "Fișiere imagine",
    documents: "Documente",
    archiveFiles: "Fișiere arhivă",
    rawOtherFormats: "Formate raw/altele",
    completionThankYou: "Multumim pentru trimiterea dvs.!",
    completionFailedIntro: "Urmatoarele fisiere nu au putut fi incarcate:",
    completionUploadMore: "Incarca mai multe",

    // Footer
    followUs: "URMĂREȘTE-NE PE",
    footerAddress: "St. 1- Lot #3, Ap. 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© 2015 până în prezent inGroup International. Toate drepturile rezervate.",

    // Video tip
    videoTipMessage: "Consultati acest ghid pentru sfaturi privind filmarea videoclipurilor cu un smartphone:",
    videoTipLinkText: "GHID",
  },
  
  // Ukrainian
  uk: {
    language: "Мова",
    selectLanguage: "Виберіть мову",
    chooseLanguage: "Виберіть бажану мову",
    project: "Проєкт",
    selectProject: "Виберіть проєкт",
    yourName: "Ваше ім'я",
    yourEmail: "Ваш email",
    videoLanguage: "Мова відео",
    countryRecorded: "Країна, де було записано відео",
    selectFiles: "Виберіть файли",
    enterFullName: "Введіть ваше повне ім'я",
    enterEmail: "Введіть вашу email адресу",
    selectLanguageOption: "-- Виберіть мову --",
    selectCountryOption: "-- Виберіть країну --",
    selectProjectOption: "-- Виберіть проєкт --",
    uploadAllFiles: "Завантажити ВСІ файли",
    uploading: "Завантаження...",
    retry: "Повторити",
    clearAll: "Очистити все",
    chooseFiles: "Виберіть ваші файли",
    selectFilesToShare: "Виберіть файли, якими хочете поділитися",
    uploadGuidelines: "Керівні принципи завантаження:",
    maxFileSize: "Максимальний розмір файлу: 10 ГБ",
    supportedFormats: "Підтримувані формати:",
    secureStorage: "Ваші файли будуть безпечно зберігатися в нашій хмарі",
    stayOnPage: "Будь ласка, залишайтеся на сторінці під час процесу завантаження",
    
    // Drag and drop
    dragDropFiles: "Перетягніть файли сюди",
    orClickToSelect: "або натисніть, щоб вибрати файли",
    dropFilesHere: "Відпустіть файли тут...",
    authorizationTitle: "Інформація про авторизацію та звільнення",
    authorizationText: "Я розумію, що мої надіслані фотографії/відео (\"Контент\") можуть бути публічно використані від імені INCRUISES INTERNATIONAL, LLC (далі називається \"Компанія\") у зв'язку з рекламою та просуванням Компанії. Я дозволяю Компанії використовувати моє ім'я, коротку біографічну інформацію та Контент, як визначено в цій формі. Цим я безвідкличне дозволяю Компанії копіювати, виставляти, публікувати або поширювати Контент з метою реклами програм Компанії або для будь-яких інших законних цілей. Ці заяви можуть бути використані в друкованих виданнях, мультимедійних презентаціях, на веб-сайтах або в будь-яких інших засобах поширення. Крім того, я погоджуюся, що не буду пред'являти жодних грошових або інших претензій до Компанії за використання Контенту. Крім того, я відмовляюся від будь-якого права перевіряти або затверджувати готовий продукт, включаючи письмовий текст, в якому з'являється моє ім'я, зображення або Контент. Цим я звільняю та звільняю Компанію від усіх претензій, вимог та підстав для позову, які я, мої спадкоємці, представники, виконавці, адміністратори або будь-які інші особи, що діють від мого імені або від імені мого майна, маю або можу мати в зв'язку з цим дозволом.",
    consentCheckbox: "Я прочитав інформацію про авторизацію та звільнення і даю свою згоду на використання, як зазначено вище.",
    nameRequired: "Ім'я обов'язкове",
    nameMinLength: "Ім'я повинно містити принаймні 2 символи",
    nameMaxLength: "Ім'я повинно містити менше 100 символів",
    nameInvalidChars: "Ім'я може містити лише літери, пробіли, дефіси та апострофи",
    emailRequired: "Email обов'язковий",
    emailInvalid: "Будь ласка, введіть дійсну email адресу",
    emailTooLong: "Email адреса занадто довга",
    projectRequired: "Будь ласка, виберіть проєкт.",
    consentRequired: "Будь ласка, прочитайте та прийміть інформацію про авторизацію та звільнення.",
    fillName: "Будь ласка, введіть дійсне ім'я для увімкнення вибору файлів.",
    fillEmail: "Будь ласка, введіть дійсний email для увімкнення вибору файлів.",
    selectProjectRequired: "Будь ласка, виберіть проєкт для увімкнення вибору файлів.",
    acceptConsent: "Будь ласка, прочитайте та прийміть інформацію про авторизацію та звільнення вище для увімкнення вибору файлів.",
    fillNameAndEmail: "Будь ласка, введіть дійсне ім'я та email для увімкнення вибору файлів.",
    selectProjectAndConsent: "Будь ласка, виберіть проєкт та прийміть інформацію про авторизацію та звільнення для увімкнення вибору файлів.",
    selectProjectAndFill: "Будь ласка, виберіть проєкт та введіть дійсний {field} для увімкнення вибору файлів.",
    fillAndConsent: "Будь ласка, введіть дійсний {field} та прийміть інформацію про авторизацію та звільнення для увімкнення вибору файлів.",
    allRequired: "Будь ласка, виберіть проєкт, заповніть усі обов'язкові поля (ім'я, email) дійсною інформацією та прийміть інформацію про авторизацію та звільнення для увімкнення вибору файлів.",
    uploadsHistory: "Історія завантажень",
    initializing: "Ініціалізація",
    ready: "Готово",
    queued: "В черзі",
    uploadingStatus: "Завантаження",
    paused: "Призупинено",
    completed: "Завершено",
    cancelled: "Скасовано",
    error: "Помилка",
    loadingProjects: "Завантаження проєктів...",
    failedToLoadProjects: "Не вдалося завантажити проєкти.",
    cannotConnect: "Неможливо підключитися до сервера. Будь ласка, переконайтеся, що сервер працює.",
    uploadingForProject: "Ви завантажите файли для проєкту",
    projectLabel: ".",
    cannotChangeProject: "Неможливо змінити проєкт. Будь ласка, спочатку завантажте, скасуйте або видаліть усі файли поточного проєкту.",
    required: "*",
    upload: "Завантажити",
    resume: "Відновити",
    pause: "Призупинити",
    cancel: "Скасувати",
    current: "(Поточний)",
    errorLabel: "Помилка:",
    removeFromList: "Видалити зі списку завантажень",
    dismissError: "Закрити помилку",
    readyForUploading: "готово до завантаження",
    videoFiles: "Відео файли",
    audioFiles: "Аудіо файли",
    imageFiles: "Файли зображень",
    documents: "Документи",
    archiveFiles: "Архівні файли",
    rawOtherFormats: "Raw/Інші формати",
    completionThankYou: "Дякуємо за ваше подання!",
    completionFailedIntro: "Наступні файли не вдалося завантажити:",
    completionUploadMore: "Завантажити ще",

    // Footer
    followUs: "ПІДПИСУЙТЕСЯ НА НАС",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© inGroup International, з 2015 року. Усі права захищено.",

    // Video tip
    videoTipMessage: "Ознайомтесь з порадами щодо зйомки відео на смартфон:",
    videoTipLinkText: "ПОСІБНИК",
  },
  
  // Uzbek
  uz: {
    language: "Til",
    selectLanguage: "Tilni tanlang",
    chooseLanguage: "O'zingizga qulay tilni tanlang",
    project: "Loyiha",
    selectProject: "Loyihani tanlang",
    yourName: "Ismingiz",
    yourEmail: "Elektron pochta manzilingiz",
    videoLanguage: "Video tili",
    countryRecorded: "Video yozilgan mamlakat",
    selectFiles: "Fayllarni tanlang",
    enterFullName: "To'liq ismingizni kiriting",
    enterEmail: "Elektron pochta manzilingizni kiriting",
    selectLanguageOption: "-- Tilni tanlang --",
    selectCountryOption: "-- Mamlakatni tanlang --",
    selectProjectOption: "-- Loyihani tanlang --",
    uploadAllFiles: "BARCHA fayllarni yuklash",
    uploading: "Yuklanmoqda...",
    retry: "Qayta urinish",
    clearAll: "Hammasini tozalash",
    chooseFiles: "Fayllaringizni tanlang",
    selectFilesToShare: "Baham ko'rmoqchi bo'lgan fayllarni tanlang",
    uploadGuidelines: "Yuklash qoidalari:",
    maxFileSize: "Maksimal fayl hajmi: 10 GB",
    supportedFormats: "Qo'llab-quvvatlanadigan formatlar:",
    secureStorage: "Fayllaringiz bizning bulutimizda xavfsiz saqlanadi",
    stayOnPage: "Yuklash jarayoni davomida sahifada qoling",
    
    // Drag and drop
    dragDropFiles: "Fayllarni bu yerga sudrab tashlang",
    orClickToSelect: "yoki fayllarni tanlash uchun bosing",
    dropFilesHere: "Fayllarni bu yerga tashlang...",
    authorizationTitle: "Ruxsat va ozod qilish ma'lumotlari",
    authorizationText: "Men yuborgan foto/videolarim (\"Kontent\") INCRUISES INTERNATIONAL, LLC (keyingi o'rinlarda \"Kompaniya\" deb ataladi) nomidan Kompaniyani targ'ib qilish va targ'ibot bilan bog'liq holda ommaviy foydalanishi mumkinligini tushunaman. Men Kompaniyaga ushbu formada belgilanganidek mening ismim, qisqa biografik ma'lumotlarim va Kontentni foydalanishga ruxsat beraman. Shu orqali men Kompaniyaning dasturlarini targ'ib qilish maqsadida yoki boshqa qonuniy maqsadlar uchun Kontentni nusxalash, ko'rsatish, nashr etish yoki tarqatishga qaytarib bo'lmaydigan ruxsat beraman. Ushbu bayonotlar bosma nashrlarda, multimedia taqdimotlarida, veb-saytlarda yoki boshqa tarqatish vositalarida ishlatilishi mumkin. Bundan tashqari, men Kontentni ishlatish uchun Kompaniyaga qarshi pul yoki boshqa da'volar qilmasligimga rozi bo'laman. Bundan tashqari, mening ismim, suratim yoki Kontent paydo bo'lgan tayyor mahsulotni, jumladan yozma matnni tekshirish yoki tasdiqlash huquqimdan voz kechaman. Shu orqali men Kompaniyani men, mening merosxo'rlarim, vakillarim, ijrochilar, ma'murlar yoki mening nomimdan yoki mening mulkim nomidan harakat qiladigan boshqa shaxslar ushbu ruxsat tufayli ega bo'lishi yoki bo'lishi mumkin bo'lgan barcha da'volar, talablar va ish qo'zg'atish sabablaridan himoya qilaman va ozod qilaman.",
    consentCheckbox: "Men ruxsat va ozod qilish ma'lumotlarini o'qidim va yuqorida ko'rsatilgandek foydalanishga rozilik beraman.",
    nameRequired: "Ism talab qilinadi",
    nameMinLength: "Ism kamida 2 belgidan iborat bo'lishi kerak",
    nameMaxLength: "Ism 100 belgidan kam bo'lishi kerak",
    nameInvalidChars: "Ism faqat harflar, bo'shliqlar, defislar va apostroflarni o'z ichiga olishi mumkin",
    emailRequired: "Elektron pochta talab qilinadi",
    emailInvalid: "Iltimos, to'g'ri elektron pochta manzilini kiriting",
    emailTooLong: "Elektron pochta manzili juda uzun",
    projectRequired: "Iltimos, loyihani tanlang.",
    consentRequired: "Iltimos, ruxsat va ozod qilish ma'lumotlarini o'qing va qabul qiling.",
    fillName: "Fayl tanlashni faollashtirish uchun to'g'ri ism kiriting.",
    fillEmail: "Fayl tanlashni faollashtirish uchun to'g'ri elektron pochta kiriting.",
    selectProjectRequired: "Fayl tanlashni faollashtirish uchun loyihani tanlang.",
    acceptConsent: "Fayl tanlashni faollashtirish uchun yuqoridagi ruxsat va ozod qilish ma'lumotlarini o'qing va qabul qiling.",
    fillNameAndEmail: "Fayl tanlashni faollashtirish uchun to'g'ri ism va elektron pochtani kiriting.",
    selectProjectAndConsent: "Fayl tanlashni faollashtirish uchun loyihani tanlang va ruxsat va ozod qilish ma'lumotlarini qabul qiling.",
    selectProjectAndFill: "Fayl tanlashni faollashtirish uchun loyihani tanlang va to'g'ri {field} kiriting.",
    fillAndConsent: "Fayl tanlashni faollashtirish uchun to'g'ri {field} kiriting va ruxsat va ozod qilish ma'lumotlarini qabul qiling.",
    allRequired: "Fayl tanlashni faollashtirish uchun loyihani tanlang, barcha majburiy maydonlarni (ism, elektron pochta) to'g'ri ma'lumotlar bilan to'ldiring va ruxsat va ozod qilish ma'lumotlarini qabul qiling.",
    uploadsHistory: "Yuklash tarixi",
    initializing: "Boshlash",
    ready: "Tayyor",
    queued: "Navbatda",
    uploadingStatus: "Yuklanmoqda",
    paused: "To'xtatilgan",
    completed: "Tugallandi",
    cancelled: "Bekor qilindi",
    error: "Xato",
    loadingProjects: "Loyihalar yuklanmoqda...",
    failedToLoadProjects: "Loyihalarni yuklab bo'lmadi.",
    cannotConnect: "Serverni ulab bo'lmadi. Iltimos, server ishlayotganligiga ishonch hosil qiling.",
    uploadingForProject: "Loyihaga fayllarni yuklaysiz",
    projectLabel: ".",
    cannotChangeProject: "Loyihani o'zgartirib bo'lmaydi. Iltimos, avval joriy loyihaning barcha fayllarini yuklang, bekor qiling yoki o'chiring.",
    required: "*",
    upload: "Yuklash",
    resume: "Davom ettirish",
    pause: "To'xtatish",
    cancel: "Bekor qilish",
    current: "(Joriy)",
    errorLabel: "Xato:",
    removeFromList: "Yuklash ro'yxatidan olib tashlash",
    dismissError: "Xatoni yopish",
    readyForUploading: "yuklashga tayyor",
    videoFiles: "Video fayllar",
    audioFiles: "Audio fayllar",
    imageFiles: "Rasm fayllari",
    documents: "Hujjatlar",
    archiveFiles: "Arxiv fayllari",
    rawOtherFormats: "Raw/Boshqa formatlar",
    completionThankYou: "Yuborilganingiz uchun rahmat!",
    completionFailedIntro: "Quyidagi fayllarni yuklab bo'lmadi:",
    completionUploadMore: "Yana yuklash",

    // Footer
    followUs: "БИЗНИ КУЗАТИБ БОРИНГ:",
    footerAddress: "St. 1- Lot #3, Suite 500 (Metro Office Park 3) Guaynabo, Puerto Rico 00968-1705",
    footerCopyright: "© 2015 йилдан ҳозирга қадар inGroup International. Барча ҳуқуқлар ҳимояланган.",

    // Video tip
    videoTipMessage: "Smartfonda video suratga olish bo'yicha maslahatlar uchun ushbu qo'llanmani ko'ring:",
    videoTipLinkText: "QO'LLANMA",
  },
  
  // Chinese
  zh: {
    language: "语言",
    selectLanguage: "选择语言",
    chooseLanguage: "选择您偏好的语言",
    project: "项目",
    selectProject: "选择项目",
    yourName: "您的姓名",
    yourEmail: "您的电子邮件",
    videoLanguage: "视频语言",
    countryRecorded: "视频录制国家",
    selectFiles: "选择文件",
    enterFullName: "输入您的全名",
    enterEmail: "输入您的电子邮件地址",
    selectLanguageOption: "-- 选择语言 --",
    selectCountryOption: "-- 选择国家 --",
    selectProjectOption: "-- 选择项目 --",
    uploadAllFiles: "上传所有文件",
    uploading: "上传中...",
    retry: "重试",
    clearAll: "清除全部",
    chooseFiles: "选择您的文件",
    selectFilesToShare: "选择您要共享的文件",
    uploadGuidelines: "上传指南:",
    maxFileSize: "最大文件大小: 10 GB",
    supportedFormats: "支持的格式:",
    secureStorage: "您的文件将安全地存储在我们的云中",
    stayOnPage: "请在上传过程中停留在页面上",
    
    // Drag and drop
    dragDropFiles: "将文件拖放到此处",
    orClickToSelect: "或点击选择文件",
    dropFilesHere: "将文件放到此处...",
    authorizationTitle: "授权和发布信息",
    authorizationText: "我理解我提交的照片/视频（\"内容\"）可以代表 INCRUISES INTERNATIONAL, LLC（以下简称\"公司\"）在与公司宣传和推广相关的情况下公开使用。我授权公司使用我的姓名、简要传记信息以及本表格中定义的内容。我特此不可撤销地授权公司为宣传公司计划或任何其他合法目的而复制、展示、发布或分发内容。这些声明可用于印刷出版物、多媒体演示、网站或任何其他分发媒体。此外，我同意不会因使用内容而向公司提出任何金钱或其他索赔。此外，我放弃检查或批准成品（包括书面文本）的任何权利，其中出现我的姓名、肖像或内容。我特此免除并解除公司因本授权而可能或可能产生的所有索赔、要求和诉讼原因，这些索赔、要求和诉讼原因由我、我的继承人、代表、执行人、管理员或任何其他以我的名义或我的财产名义行事的人提出。",
    consentCheckbox: "我已阅读授权和发布信息，并同意按上述指示使用。",
    nameRequired: "姓名是必填项",
    nameMinLength: "姓名必须至少包含2个字符",
    nameMaxLength: "姓名必须少于100个字符",
    nameInvalidChars: "姓名只能包含字母、空格、连字符和撇号",
    emailRequired: "电子邮件是必填项",
    emailInvalid: "请输入有效的电子邮件地址",
    emailTooLong: "电子邮件地址太长",
    projectRequired: "请选择项目。",
    consentRequired: "请阅读并接受授权和发布信息。",
    fillName: "请输入有效的姓名以启用文件选择。",
    fillEmail: "请输入有效的电子邮件以启用文件选择。",
    selectProjectRequired: "请选择项目以启用文件选择。",
    acceptConsent: "请阅读并接受上述授权和发布信息以启用文件选择。",
    fillNameAndEmail: "请输入有效的姓名和电子邮件以启用文件选择。",
    selectProjectAndConsent: "请选择项目并接受授权和发布信息以启用文件选择。",
    selectProjectAndFill: "请选择项目并输入有效的{field}以启用文件选择。",
    fillAndConsent: "请输入有效的{field}并接受授权和发布信息以启用文件选择。",
    allRequired: "请选择项目，填写所有必填字段（姓名、电子邮件）并提供有效信息，并接受授权和发布信息以启用文件选择。",
    uploadsHistory: "上传历史",
    initializing: "初始化中",
    ready: "就绪",
    queued: "排队中",
    uploadingStatus: "上传中",
    paused: "已暂停",
    completed: "已完成",
    cancelled: "已取消",
    error: "错误",
    loadingProjects: "正在加载项目...",
    failedToLoadProjects: "无法加载项目。",
    cannotConnect: "无法连接到服务器。请确保服务器正在运行。",
    uploadingForProject: "您将为项目上传文件",
    projectLabel: "。",
    cannotChangeProject: "无法更改项目。请先上传、取消或删除当前项目的所有文件。",
    required: "*",
    upload: "上传",
    resume: "恢复",
    pause: "暂停",
    cancel: "取消",
    current: "（当前）",
    errorLabel: "错误:",
    removeFromList: "从上传列表中删除",
    dismissError: "关闭错误",
    readyForUploading: "准备上传",
    videoFiles: "视频文件",
    audioFiles: "音频文件",
    imageFiles: "图像文件",
    documents: "文档",
    archiveFiles: "归档文件",
    rawOtherFormats: "原始/其他格式",
    completionThankYou: "感谢您的提交！",
    completionFailedIntro: "以下文件上传失败：",
    completionUploadMore: "继续上传",

    // Footer
    followUs: "关注我们",
    footerAddress: "圣1街，地块3号，500室（地铁办公园区3号楼）瓜亚纳博，波多黎各 00968-1705",
    footerCopyright: "© 2015 年至今，inGroup International 版权所有。",

    // Video tip
    videoTipMessage: "查看此指南，了解使用智能手机拍摄视频的技巧：",
    videoTipLinkText: "指南",
  },
};

// Default language
export const DEFAULT_LANGUAGE = 'en';

// Get translation for a key, with fallback to English
export function getTranslation(lang, key, params = {}) {
  const langTranslations = translations[lang] || translations[DEFAULT_LANGUAGE];
  let translation = langTranslations[key] || translations[DEFAULT_LANGUAGE][key] || key;
  
  // Replace parameters in translation
  if (params && Object.keys(params).length > 0) {
    Object.keys(params).forEach(param => {
      translation = translation.replace(`{${param}}`, params[param]);
    });
  }
  
  return translation;
}

